(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5582],{

/***/ 28563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M21 5H3C2.4 5 2 5.4 2 6V10V11V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V11V10V6C22 5.4 21.6 5 21 5ZM20 7V9H4V7H20ZM4 18V12H20V18H4Z"
}), "CreditCard"));


/***/ }),

/***/ 99142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ PAYMENT_FAIL_EVENT; },
/* harmony export */   "s": function() { return /* binding */ PAYMENT_SUCCESS_EVENT; }
/* harmony export */ });
var PAYMENT_SUCCESS_EVENT = "paymentHasFinishedSuccessfully";
var PAYMENT_FAIL_EVENT = "paymentHasFailed";


/***/ }),

/***/ 8310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ YEAR_PREFIX; },
/* harmony export */   "h": function() { return /* binding */ CREDIT_CARD_MASK; }
/* harmony export */ });
var YEAR_PREFIX = "20";
var CREDIT_CARD_MASK = "•••• •••• •••• •••• ";


/***/ }),

/***/ 13473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_CreditCardInfo; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ./client/icons/CreditCard.tsx
var CreditCard = __webpack_require__(28563);
// EXTERNAL MODULE: ./src/comps/CreditCardInfo/styles.js
var styles = __webpack_require__(65060);
// EXTERNAL MODULE: ./client/components/InputLine/index.js
var InputLine = __webpack_require__(71581);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./src/comps/CreditCardInfo/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    expiresOn: {
        id: "global.card-expiration"
    }
});
/* harmony default export */ var CreditCardInfo_messages = (messages);

// EXTERNAL MODULE: ./src/comps/CreditCardInfo/constants.js
var constants = __webpack_require__(8310);
;// CONCATENATED MODULE: ./src/comps/CreditCardInfo/index.js











var CreditCardInfo = function(param) {
    var holder = param.holder, brand = param.brand, number = param.number, expiryDate = param.expiryDate, inputRadioWrapped = param.inputRadioWrapped;
    var getFormattedDate = function getFormattedDate(date) {
        var month = date.substring(0, 2);
        var year = date.substring(2, 4);
        return "".concat(month, "/").concat(constants/* YEAR_PREFIX */.H).concat(year);
    };
    var getLastFourDigits = function getLastFourDigits(creditCardNumber) {
        return creditCardNumber.substring(creditCardNumber.length - 4, creditCardNumber.length);
    };
    var ref = (0,react.useState)(true), checked = ref[0], setCheck = ref[1];
    var CreditCardResume = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CreditCardWrapper */.Ye, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Number */.Mr, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCard/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Brand */.H2, {
                            children: brand
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CreditCardNumber */.QF, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CreditCardNumberMask */.Pk, {
                                    children: constants/* CREDIT_CARD_MASK */.h
                                }),
                                getLastFourDigits(number)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Holder */.c9, {
                    children: holder
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ExpiringDate */.wK, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CreditCardInfo_messages.expiresOn), {
                        tagName: "span",
                        values: {
                            date: getFormattedDate(expiryDate)
                        }
                    }))
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CreditCardInfoBase */.Ot, {
        withBorder: inputRadioWrapped,
        children: inputRadioWrapped ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLine/* default */.Z, {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardResume, {}),
            id: "credit-card-method",
            name: "paymentMethod",
            checked: checked,
            type: "radio",
            value: "".concat(checked),
            onChange: function() {
                return setCheck(!checked);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardResume, {})
    });
};
CreditCardInfo.propTypes = {
    holder: (prop_types_default()).string.isRequired,
    brand: (prop_types_default()).string.isRequired,
    number: (prop_types_default()).string.isRequired,
    expiryDate: (prop_types_default()).string.isRequired,
    inputRadioWrapped: (prop_types_default()).bool
};
/* harmony default export */ var comps_CreditCardInfo = (CreditCardInfo);


/***/ }),

/***/ 65060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ Brand; },
/* harmony export */   "Mr": function() { return /* binding */ Number; },
/* harmony export */   "Ot": function() { return /* binding */ CreditCardInfoBase; },
/* harmony export */   "Pk": function() { return /* binding */ CreditCardNumberMask; },
/* harmony export */   "QF": function() { return /* binding */ CreditCardNumber; },
/* harmony export */   "Ye": function() { return /* binding */ CreditCardWrapper; },
/* harmony export */   "c9": function() { return /* binding */ Holder; },
/* harmony export */   "wK": function() { return /* binding */ ExpiringDate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12411);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);
/* harmony import */ var client_components_InputLine_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52342);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  border: 2px solid ",
        ";\n  padding-block: 12px;\n  padding-inline: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  ",
        ";\n\n  ",
        " {\n    margin-inline-end: 12px;\n    &:checked {\n      background-color: ",
        ";\n      &::after {\n        background-color: ",
        ";\n      }\n    }\n  }\n\n  ",
        " {\n    color: ",
        ";\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  color: ",
        ";\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding-block-end: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-inline: 8px;\n  margin-block: 0;\n  text-transform: capitalize;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 150%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-block-end: 4px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n\n  span {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var BaseWithBorder = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1);
var CreditCardInfoBase = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CreditCardInfoBase",
    componentId: "sc-4e0fb96b-0"
})(_templateObject1(), function(props) {
    return props.withBorder && BaseWithBorder;
}, client_components_InputLine_styles__WEBPACK_IMPORTED_MODULE_2__/* .InputRadio */ .rW, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1, client_components_InputLine_styles__WEBPACK_IMPORTED_MODULE_2__/* .LabelRadio */ .A$, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1);
var CreditCardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CreditCardWrapper",
    componentId: "sc-4e0fb96b-1"
})(_templateObject2(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1);
var Number = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Number",
    componentId: "sc-4e0fb96b-2"
})(_templateObject3());
var Brand = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Brand",
    componentId: "sc-4e0fb96b-3"
})(_templateObject4());
var CreditCardNumber = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__CreditCardNumber",
    componentId: "sc-4e0fb96b-4"
})(_templateObject5());
var CreditCardNumberMask = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__CreditCardNumberMask",
    componentId: "sc-4e0fb96b-5"
})(_templateObject6());
var Holder = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Holder",
    componentId: "sc-4e0fb96b-6"
})(_templateObject7());
var ExpiringDate = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ExpiringDate",
    componentId: "sc-4e0fb96b-7"
})(_templateObject8(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2);


/***/ }),

/***/ 71659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



var EmbedHtml = function(param) {
    var children = param.children, _isBase64 = param.isBase64, isBase64 = _isBase64 === void 0 ? false : _isBase64;
    var executeScriptTags = function executeScriptTags() {
        var script = embedRef.current.querySelector("script");
        var reloadedScript = document.createElement("script");
        reloadedScript.innerHTML = script.innerHTML;
        embedRef.current.appendChild(reloadedScript);
    };
    var embedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!children) {
            return;
        }
        embedRef.current.innerHTML = isBase64 ? atob(children) : children;
        executeScriptTags();
    }, [
        children,
        isBase64
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: embedRef
    });
};
EmbedHtml.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    isBase64: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (EmbedHtml);


/***/ }),

/***/ 89561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_PaymentForm; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var components_message = __webpack_require__(42670);
// EXTERNAL MODULE: ./src/comps/PaymentForm/constants.js
var constants = __webpack_require__(4708);
// EXTERNAL MODULE: ./src/effects/User/actions.ts
var actions = __webpack_require__(25595);
// EXTERNAL MODULE: ./src/effects/User/selectors.ts
var selectors = __webpack_require__(91907);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
// EXTERNAL MODULE: ./src/hooks/useSystem.ts
var useSystem = __webpack_require__(72337);
// EXTERNAL MODULE: ./client/types/checkout/index.js
var checkout = __webpack_require__(43026);
// EXTERNAL MODULE: ./src/comps/Image/constants.ts
var Image_constants = __webpack_require__(3282);
// EXTERNAL MODULE: ./src/comps/Image/index.tsx
var Image = __webpack_require__(55880);
// EXTERNAL MODULE: ./src/comps/PaymentMethodsLogos/styles.module.css
var styles_module = __webpack_require__(20424);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/constants/environment.js
var environment = __webpack_require__(65003);
;// CONCATENATED MODULE: ./src/comps/PaymentMethodsLogos/constants.js



var PAYMENT_METHOD_LOGO_WIDTH = 34;
var PAYMENT_METHOD_LOGO_HEIGHT = 24;
var _obj;
var PAYMENT_METHOD_LOGO_SRC_MAPPER = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_VISA_ID */.Xc, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/210304_visa.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_MASTERCARD_ID */.E_, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/210304_mastercard.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_AMEX_ID */.xu, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/210304_amex.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_CREDITCARD_ID */.df, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/241127_creditcard.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_GIROPAY_ID */.t3, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/210304_giropay.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_KLARNA_ID */.gY, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/210805_klarna.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_IDEAL_ID */.t2, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/230317_ideal.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_MULTIBANCO_ID */.Sq, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/230717_multibanco.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_BANCONTACT_ID */.mD, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/230928_bancontact.svg")), (0,_define_property/* default */.Z)(_obj, constants/* PAYMENT_METHOD_APPLEPAY_ID */.aX, "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/241127_applepay.svg")), _obj);
var VALID_PAYMENT_METHOD_IDS = [
    constants/* PAYMENT_METHOD_VISA_ID */.Xc,
    constants/* PAYMENT_METHOD_MASTERCARD_ID */.E_,
    constants/* PAYMENT_METHOD_AMEX_ID */.xu,
    constants/* PAYMENT_METHOD_CREDITCARD_ID */.df,
    constants/* PAYMENT_METHOD_GIROPAY_ID */.t3,
    constants/* PAYMENT_METHOD_KLARNA_ID */.gY,
    constants/* PAYMENT_METHOD_IDEAL_ID */.t2,
    constants/* PAYMENT_METHOD_BANCONTACT_ID */.mD,
    constants/* PAYMENT_METHOD_MULTIBANCO_ID */.Sq,
    constants/* PAYMENT_METHOD_APPLEPAY_ID */.aX, 
];

;// CONCATENATED MODULE: ./src/comps/PaymentMethodsLogos/PaymentMethodLogo.js







var PaymentMethodLogo = function(param) {
    var id = param.id, _withoutBorder = param.withoutBorder, withoutBorder = _withoutBorder === void 0 ? false : _withoutBorder, _width = param.width, width = _width === void 0 ? PAYMENT_METHOD_LOGO_WIDTH : _width, _height = param.height, height = _height === void 0 ? PAYMENT_METHOD_LOGO_HEIGHT : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(!withoutBorder && (styles_module_default()).logoWithBorder, " ").concat((styles_module_default()).logo),
        "data-testid": "".concat(id, "-logo"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: PAYMENT_METHOD_LOGO_SRC_MAPPER[id],
            alt: "".concat(id, "-logo"),
            width: width,
            height: height,
            layout: Image_constants/* LAYOUT_CONTAIN */.rW
        })
    });
};
PaymentMethodLogo.propTypes = {
    id: prop_types_default().oneOf(VALID_PAYMENT_METHOD_IDS),
    withoutBorder: (prop_types_default()).bool,
    width: (prop_types_default()).number,
    height: (prop_types_default()).number
};
/* harmony default export */ var PaymentMethodsLogos_PaymentMethodLogo = (PaymentMethodLogo);

;// CONCATENATED MODULE: ./src/comps/PaymentMethodsLogos/index.tsx






var PaymentMethodsLogos = function(param) {
    var _creditCard = param.creditCard, creditCard = _creditCard === void 0 ? false : _creditCard, _checkout = param.checkout, checkout = _checkout === void 0 ? false : _checkout, apm = param.apm, _applePay = param.applePay, applePay = _applePay === void 0 ? false : _applePay, width = param.width, height = param.height;
    var overrideCreditCardLogos = (0,useMarket/* useMarket */.A)().overrideCreditCardLogos;
    var defaultPaymentMethods = [
        constants/* PAYMENT_METHOD_VISA_ID */.Xc,
        constants/* PAYMENT_METHOD_MASTERCARD_ID */.E_,
        constants/* PAYMENT_METHOD_AMEX_ID */.xu, 
    ];
    var paymentMethods = overrideCreditCardLogos || defaultPaymentMethods;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).logosContainer,
        "data-testid": "payment-logos",
        children: [
            checkout && paymentMethods.map(function(paymentMethod) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsLogos_PaymentMethodLogo, {
                    id: paymentMethod
                }, paymentMethod);
            }),
            creditCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsLogos_PaymentMethodLogo, {
                id: "creditcard"
            }),
            apm === "giropay" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsLogos_PaymentMethodLogo, {
                id: apm,
                width: width !== null && width !== void 0 ? width : 34,
                height: width !== null && width !== void 0 ? width : 24
            }),
            apm === "klarna" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsLogos_PaymentMethodLogo, {
                withoutBorder: true,
                width: width !== null && width !== void 0 ? width : 39,
                height: width !== null && width !== void 0 ? width : 24,
                id: apm
            }),
            apm === "ideal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsLogos_PaymentMethodLogo, {
                id: apm
            }),
            apm === "multibanco" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsLogos_PaymentMethodLogo, {
                id: apm
            }),
            apm === "bancontact" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsLogos_PaymentMethodLogo, {
                id: apm
            }),
            applePay && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsLogos_PaymentMethodLogo, {
                withoutBorder: true,
                width: width !== null && width !== void 0 ? width : 39,
                height: height !== null && height !== void 0 ? height : 26,
                id: "applepay"
            })
        ]
    });
};
/* harmony default export */ var comps_PaymentMethodsLogos = (PaymentMethodsLogos);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./client/icons/CreditCard.tsx
var CreditCard = __webpack_require__(28563);
// EXTERNAL MODULE: ./src/comps/PaymentForm/styles.js
var styles = __webpack_require__(40420);
;// CONCATENATED MODULE: ./src/comps/PaymentForm/PaymentConfirmationLoader.js







var PaymentConfirmationLoader = function(param) {
    var title = param.title, message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ConfirmationContainer */.q2, {
        "data-testid": "waiting-for-confirmation-message",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCard/* default */.Z, {
                size: 72
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ConfirmationTitle */.my, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, title))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, message))
        ]
    });
};
PaymentConfirmationLoader.propTypes = {
    title: prop_types_default().shape({
        id: (prop_types_default()).string.isRequired,
        defaultMessage: (prop_types_default()).string
    }).isRequired,
    message: prop_types_default().shape({
        id: (prop_types_default()).string.isRequired,
        defaultMessage: (prop_types_default()).string
    }).isRequired
};
/* harmony default export */ var PaymentForm_PaymentConfirmationLoader = (PaymentConfirmationLoader);

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./client/icons/Warning.js
var Warning = __webpack_require__(62219);
// EXTERNAL MODULE: ./src/comps/PaymentForm/styles.module.css
var PaymentForm_styles_module = __webpack_require__(58862);
var PaymentForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(PaymentForm_styles_module);
// EXTERNAL MODULE: ./client/pages/constants.ts
var pages_constants = __webpack_require__(11535);
;// CONCATENATED MODULE: ./src/comps/PaymentForm/PaymentErrorMessage.tsx







function getErrorMessages(subCode) {
    if (subCode === pages_constants/* ERROR_CODES.INVALID_CARD */.O.INVALID_CARD) {
        return {
            errorMessageTitle: {
                id: "payment.try-again-cta"
            },
            errorMessage: {
                id: "payment.try-again-message"
            }
        };
    }
    var isBankError = constants/* bankErrorCodes.includes */.PQ.includes(subCode);
    return {
        errorMessageTitle: isBankError ? {
            id: "payment.try-contacting-bank"
        } : {
            id: "error.default"
        },
        errorMessage: !isBankError ? {
            id: "payment.try_again_other_card"
        } : null
    };
}
var PaymentErrorMessage = function(param) {
    var subCode = param.subCode;
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    var ref = getErrorMessages(subCode), errorMessageTitle = ref.errorMessageTitle, errorMessage = ref.errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "alert",
        className: (PaymentForm_styles_module_default()).errorMessageContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PaymentForm_styles_module_default()).errorMessage,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PaymentForm_styles_module_default()).errorMessageTitle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {}),
                        formatMessage(errorMessageTitle)
                    ]
                }),
                errorMessage && formatMessage(errorMessage),
                 false ? 0 : null
            ]
        })
    });
};
/* harmony default export */ var PaymentForm_PaymentErrorMessage = (PaymentErrorMessage);

// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 105 modules
var src = __webpack_require__(55349);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/Lock.js



/* harmony default export */ var Lock = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M15 8H13V5C13 2.2 10.8 0 8 0C5.2 0 3 2.2 3 5V8H1C0.4 8 0 8.4 0 9V19C0 19.6 0.4 20 1 20H15C15.6 20 16 19.6 16 19V9C16 8.4 15.6 8 15 8ZM5 5C5 3.3 6.3 2 8 2C9.7 2 11 3.3 11 5V8H5V5ZM14 18H2V10H4H12H14V18Z"
}), "Lock", 18, "0 0 18 18"));

// EXTERNAL MODULE: ./src/comps/PaymentForm/utils.ts
var utils = __webpack_require__(47270);
// EXTERNAL MODULE: ./src/pages/book/payment-data/errorHandler.ts
var errorHandler = __webpack_require__(7978);
// EXTERNAL MODULE: ./src/utils/generateTrustedDomains.ts
var generateTrustedDomains = __webpack_require__(50814);
// EXTERNAL MODULE: ./src/comps/Molecules/PaymentModal/styles.module.css
var PaymentModal_styles_module = __webpack_require__(65126);
var PaymentModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(PaymentModal_styles_module);
// EXTERNAL MODULE: ./client/icons/Spinner.js
var Spinner = __webpack_require__(69763);
// EXTERNAL MODULE: ./src/comps/Molecules/PaymentModal/LoadingSpinner/styles.module.css
var LoadingSpinner_styles_module = __webpack_require__(96422);
var LoadingSpinner_styles_module_default = /*#__PURE__*/__webpack_require__.n(LoadingSpinner_styles_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/PaymentModal/LoadingSpinner/index.tsx




function LoadingSpinner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (LoadingSpinner_styles_module_default()).loadingSpinner,
        "data-testid": "loading-spinner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
            size: 18
        })
    });
}

// EXTERNAL MODULE: ./src/comps/Atom/Text/index.tsx
var Text = __webpack_require__(63586);
;// CONCATENATED MODULE: ./src/comps/Molecules/PaymentModal/Loading3dsValidation.tsx








var Loading3dsValidation = function(param) {
    var isFirstLoad = param.isFirstLoad;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (PaymentModal_styles_module_default()).loader,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PaymentModal_styles_module_default()).message,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "captionL",
                                weight: "weight2",
                                children: intl.formatMessage({
                                    id: isFirstLoad ? "redirect.copy-1" : "redirect.copy-3"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "captionL",
                                weight: "weight2",
                                children: intl.formatMessage({
                                    id: "redirect.copy-2"
                                })
                            })
                        ]
                    })
                ]
            }),
            isFirstLoad && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PaymentModal_styles_module_default()).preloader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: "An illustration of a person planting a flag",
                        src: "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/250401_illustration-flag.png"),
                        className: (PaymentModal_styles_module_default()).preloaderImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "titleXs",
                        weight: "weight4",
                        children: intl.formatMessage({
                            id: "redirect.title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "textBodyL",
                        weight: "weight2",
                        children: intl.formatMessage({
                            id: "redirect.copy-4"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PaymentModal_Loading3dsValidation = (Loading3dsValidation);

// EXTERNAL MODULE: ./client/icons/Shield.js
var Shield = __webpack_require__(45920);
;// CONCATENATED MODULE: ./src/comps/Molecules/PaymentModal/LoadingPayment.tsx









var LoadingPayment = function() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (PaymentModal_styles_module_default()).loader,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PaymentModal_styles_module_default()).message,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "captionL",
                                weight: "weight2",
                                children: intl.formatMessage({
                                    id: "global.process-payment-wait"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "captionL",
                                weight: "weight2",
                                children: intl.formatMessage({
                                    id: "redirect.copy-60s"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PaymentModal_styles_module_default()).preloader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: "An illustration of a person planting a flag",
                        src: "".concat(environment/* PATH_IMAGES_CDN */.VZ, "/250401_illustration-flag.png"),
                        className: (PaymentModal_styles_module_default()).preloaderImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PaymentModal_styles_module_default()).secureConnection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Shield["default"], {
                                width: 24,
                                height: 24,
                                fill: "var(--color--semantic--success--500)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "textBodyL",
                                weight: "weight4",
                                children: intl.formatMessage({
                                    id: "global.secure-connection"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PaymentModal_LoadingPayment = (LoadingPayment);

;// CONCATENATED MODULE: ./src/comps/Molecules/PaymentModal/index.tsx












var PaymentModal = function(param) {
    var iframeData = param.iframeData, onFail = param.onFail;
    var iframeUrl = iframeData.url, paymentType = iframeData.type;
    var intl = (0,useIntl/* default */.Z)();
    var iframeRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)(true), isFirstLoad = ref1[0], setIsFirstLoad = ref1[1];
    var isMountedRef = (0,react.useRef)(true);
    var is3ds = paymentType === utils/* PaymentMessages.VALIDATION_3DS */.on.VALIDATION_3DS;
    var dispatch = (0,es/* useDispatch */.I0)();
    var trustedDomains = (0,react.useMemo)(function() {
        return (0,generateTrustedDomains/* generateTrustedDomains */.O)();
    }, []);
    var isTrustedDomain = (0,react.useCallback)(function(origin) {
        if (trustedDomains.length > 0) {
            return trustedDomains.some(function(domain) {
                return origin.includes(domain);
            });
        }
        return false;
    }, [
        trustedDomains
    ]);
    var handleOnFail = (0,react.useCallback)(function(error) {
        onFail("Payment modal error: ".concat(error));
    }, [
        onFail
    ]);
    var handleIframeLoad = (0,react.useCallback)(function() {
        if (isFirstLoad && is3ds) {
            try {
                requestAnimationFrame(function() {
                    if (isMountedRef.current) {
                        setIsLoading(false);
                        setIsFirstLoad(false);
                    }
                });
            } catch (error) {
                handleOnFail("Error in iframe load handler: ".concat(error));
            }
        }
    }, [
        handleOnFail,
        isFirstLoad,
        is3ds
    ]);
    (0,react.useEffect)(function() {
        var handlePopState = function() {
            setIsLoading(true);
        };
        window.addEventListener("popstate", handlePopState);
        return function() {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);
    var safeRedirect = (0,react.useCallback)(function(redirectUrl) {
        if (!redirectUrl) return;
        var canUseTopLocation = false;
        try {
            var ref;
            canUseTopLocation = Boolean((ref = window.top) === null || ref === void 0 ? void 0 : ref.location);
        } catch (e) {
            canUseTopLocation = false;
        }
        try {
            var ref1;
            if (canUseTopLocation && ((ref1 = window.top) === null || ref1 === void 0 ? void 0 : ref1.location)) {
                window.top.location.href = redirectUrl;
            } else {
                var a = document.createElement("a");
                a.href = redirectUrl;
                a.target = "_top";
                a.rel = "noopener noreferrer";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        } catch (error) {
            handleOnFail("Failed to redirect: ".concat(error));
        }
    }, [
        handleOnFail
    ]);
    var processSuccessfulPayment = function(payload, dispatch) {
        var status = payload.status, purchaseId = payload.purchaseId, error = payload.error, type = payload.type;
        if ((0,utils/* isPaymentStatus */.lc)(status) && status === utils/* PaymentStatus.SUCCESS */.bG.SUCCESS) {
            if (!error) {
                (0,errorHandler/* handleSuccess */.sE)({
                    dispatch: dispatch,
                    purchaseId: purchaseId,
                    type: type
                });
                return;
            }
            if ((error === null || error === void 0 ? void 0 : error.eventName) === "payment_attempt") {
                (0,errorHandler/* handleIframeError */.lw)({
                    error: error,
                    dispatch: dispatch,
                    purchaseId: purchaseId
                });
                (0,errorHandler/* handleSuccess */.sE)({
                    dispatch: dispatch,
                    purchaseId: purchaseId,
                    type: type
                });
            }
        }
    };
    var processPaymentMessage = function(payload, type, dispatch) {
        var redirectUrl = payload.redirectUrl, error = payload.error, purchaseId = payload.purchaseId;
        if (!(0,utils/* isPaymentType */.oQ)(type)) {
            throw new Error("Invalid payment type");
        }
        setIsLoading(true);
        setIsFirstLoad(false);
        processSuccessfulPayment(payload, dispatch);
        if (error) {
            (0,errorHandler/* handleIframeError */.lw)({
                error: error,
                dispatch: dispatch,
                purchaseId: purchaseId
            });
        }
        safeRedirect(redirectUrl);
    };
    var isValidMessage = function(event) {
        var ref;
        return isTrustedDomain(event.origin) && Object.values(utils/* PaymentMessages */.on).includes((ref = event.data) === null || ref === void 0 ? void 0 : ref.type);
    };
    (0,react.useEffect)(function() {
        var handleMessage = function(event) {
            if (!isValidMessage(event)) return;
            try {
                var _data = event.data, payload = _data.payload, type = _data.type;
                var redirectUrl = payload.redirectUrl;
                if (redirectUrl && payload) {
                    processPaymentMessage(payload, type, dispatch);
                }
            } catch (error) {
                handleOnFail("Error processing message: ".concat(error));
            }
        };
        window.addEventListener("message", handleMessage);
        return function() {
            isMountedRef.current = false;
            window.removeEventListener("message", handleMessage);
        };
    }, [
        isTrustedDomain,
        handleOnFail,
        safeRedirect
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet */.R1, {
        open: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet.Content */.R1.Content, {
            title: is3ds ? intl.formatMessage({
                id: "global.verify-payment"
            }) : intl.formatMessage({
                id: "global.process-payment"
            }),
            titleIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock, {
                width: 24,
                height: 24,
                fill: "var(--color--semantic--success--500)"
            }),
            size: "s",
            modalOnDesktop: true,
            noClose: true,
            children: [
                isLoading && (is3ds ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentModal_Loading3dsValidation, {
                    isFirstLoad: isFirstLoad
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentModal_LoadingPayment, {})),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    ref: iframeRef,
                    className: "".concat((PaymentModal_styles_module_default()).iframe, " ").concat(isLoading ? (PaymentModal_styles_module_default()).loading : (PaymentModal_styles_module_default()).loaded),
                    src: iframeUrl,
                    title: "Payment Modal",
                    loading: "eager",
                    onLoad: handleIframeLoad,
                    onError: function() {
                        return handleOnFail("Error loading payment modal iframe");
                    },
                    sandbox: "allow-same-origin allow-scripts allow-forms",
                    allow: "payment",
                    height: is3ds ? 500 : 350,
                    "data-testid": "payment-modal"
                })
            ]
        })
    });
};
/* harmony default export */ var Molecules_PaymentModal = (PaymentModal);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./client/components/InputLine/index.js
var InputLine = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/comps/Accordion/styles.module.css
var Accordion_styles_module = __webpack_require__(48358);
var Accordion_styles_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_styles_module);
;// CONCATENATED MODULE: ./src/comps/Accordion/index.js





var Accordion = function(param) {
    var sections = param.sections, selectedSectionId = param.selectedSectionId, onChange = param.onChange;
    var isSelected = function isSelected(id) {
        return selectedSectionId === id;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (Accordion_styles_module_default()).accordion,
        children: sections.map(function(param) {
            var id = param.id, title = param.title, body = param.body;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("summary", {
                "aria-expanded": isSelected(id),
                className: (Accordion_styles_module_default()).container,
                "data-testid": "section-".concat(id),
                onClick: function() {
                    return onChange(id);
                },
                onKeyDown: function(event) {
                    if (event.key === "Enter" || event.key === " ") {
                        onChange(id);
                        event.preventDefault();
                    }
                },
                tabIndex: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Accordion_styles_module_default()).title, " ").concat(isSelected(id) && (Accordion_styles_module_default()).active),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLine/* default */.Z, {
                            checked: isSelected(id),
                            label: title,
                            name: id,
                            type: "radio",
                            value: id,
                            readOnly: true
                        })
                    }),
                    isSelected(id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Accordion_styles_module_default()).body,
                        children: body
                    })
                ]
            }, id);
        })
    });
};
Accordion.propTypes = {
    sections: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).string,
        title: (prop_types_default()).node,
        body: (prop_types_default()).node
    })).isRequired,
    selectedSectionId: (prop_types_default()).string,
    onChange: (prop_types_default()).func.isRequired
};
/* harmony default export */ var comps_Accordion = (Accordion);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var client_styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/JetIframeForm/constants.js

var JET_IFRAME_PROVIDER_ID_TEST = "wX63puMyforRm2Ps7Y5VETci8SdZKBeg";
var JET_IFRAME_GLOBAL_CALLBACK_FUNCTION = "jetIframeCallback";
var JET_IFRAME_YEARS_COUNT_SELECTOR = 11;
var JET_IFRAME_INPUT_STYLES = "\n    width: 100%;\n    padding-block: 12px;\n    padding-inline: 12px;\n    font-size: 16px;\n    color: ".concat(client_styles/* colors.grey1 */.O9.grey1, ";\n    border: 2px solid ").concat(client_styles/* colors.grey4 */.O9.grey4, ";\n    border-radius: 8px;\n    box-sizing: border-box;\n");
var JET_IFRAME_RENDER_CHECK_INTERVAL = 1000;
var JET_IFRAME_RENDER_CHECK_TRIES = 10;
var CONFIRM_BUTTON_SUBMIT_VARIANT = "confirmBooking";
var CHANGE_CREDIT_CARD_BUTTON_SUBMIT_VARIANT = "changeCreditCard";

// EXTERNAL MODULE: ./src/comps/CreditCardInfo/index.js + 1 modules
var CreditCardInfo = __webpack_require__(13473);
// EXTERNAL MODULE: ./src/comps/Atom/Loader/index.tsx
var Loader = __webpack_require__(43381);
;// CONCATENATED MODULE: ./src/hooks/useWindowMessage.js

var useWindowMessage = function(callback) {
    (0,react.useEffect)(function() {
        window.addEventListener("message", callback);
        return function() {
            window.removeEventListener("message", callback);
        };
    });
};
/* harmony default export */ var hooks_useWindowMessage = (useWindowMessage);

// EXTERNAL MODULE: ./client/pages/Payment/constants.js
var Payment_constants = __webpack_require__(99142);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(12411);
;// CONCATENATED MODULE: ./src/comps/PaymentOgone/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: ",
        ";\n\n  ",
        " {\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PaymentOgoneBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PaymentOgoneBase",
    componentId: "sc-95e68233-0"
})(_templateObject());
var Iframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    displayName: "styles__Iframe",
    componentId: "sc-95e68233-1"
})(_templateObject1(), function(props) {
    return props.customSubmit ? "348px" : "450px";
}, client_styles/* updatedMedia.onlyMobile */.$c.onlyMobile, function(props) {
    return props.customSubmit ? "348px" : "500px";
});

// EXTERNAL MODULE: ./src/comps/Atom/Buttons/PrimaryButton/index.tsx
var PrimaryButton = __webpack_require__(58129);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./src/comps/PaymentOgone/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    confirmBooking: {
        id: "global.confirm-booking"
    }
});
/* harmony default export */ var PaymentOgone_messages = (messages);

;// CONCATENATED MODULE: ./src/comps/PaymentOgone/index.js













var PaymentOgone = function(param) {
    var src = param.src, onSuccess = param.onSuccess, onError = param.onError, onBeforeSubmit = param.onBeforeSubmit, disabled = param.disabled, customSubmit = param.customSubmit;
    var handleOnLoad = function handleOnLoad() {
        setIsLoading(false);
    };
    var handleIframe = function handleIframe(e) {
        var event = e === null || e === void 0 ? void 0 : e.data;
        if (event === Payment_constants/* PAYMENT_SUCCESS_EVENT */.s) {
            onSuccess();
        }
        if ((event === null || event === void 0 ? void 0 : event.status) === Payment_constants/* PAYMENT_SUCCESS_EVENT */.s) {
            onSuccess(event === null || event === void 0 ? void 0 : event.data);
        }
        if (event === Payment_constants/* PAYMENT_FAIL_EVENT */.f || (event === null || event === void 0 ? void 0 : event.status) === Payment_constants/* PAYMENT_FAIL_EVENT */.f) {
            var ref1;
            setIsSubmitting(false);
            onError();
            if ((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.src) {
                ref.current.src = src // reset iframe
                ;
            }
        }
    };
    var ref = (0,react.useRef)();
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    /* istanbul ignore next */ (0,react.useEffect)(function() {
        var ref1;
        if (!isLoading && (ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.contentWindow)) {
            ref.current.contentWindow.postMessage(disabled ? "disable" : "enable", src);
        }
    }, [
        disabled,
        isLoading,
        ref,
        src
    ]);
    function handleSumit(event) {
        return _handleSumit.apply(this, arguments);
    }
    function _handleSumit() {
        _handleSumit = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (!(typeof onBeforeSubmit === "function")) return [
                            3,
                            2
                        ];
                        setIsSubmitting(true);
                        return [
                            4,
                            onBeforeSubmit()
                        ];
                    case 1:
                        if (!_state.sent()) {
                            setIsSubmitting(false);
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(false);
                        _state.label = 2;
                    case 2:
                        ref.current.contentWindow.postMessage("submit", src);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSumit.apply(this, arguments);
    }
    hooks_useWindowMessage(handleIframe);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentOgoneBase, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe, {
                "data-testid": "payment-iframe",
                id: "payment-form-iframe",
                onLoad: handleOnLoad,
                ref: ref,
                src: src,
                title: "payment",
                customSubmit: customSubmit
            }),
            customSubmit && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                "data-testid": "payment-custom-submit",
                disabled: isLoading || disabled || isSubmitting,
                onClick: handleSumit,
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, PaymentOgone_messages.confirmBooking))
            })
        ]
    });
};
PaymentOgone.propTypes = {
    onError: (prop_types_default()).func.isRequired,
    onSuccess: (prop_types_default()).func.isRequired,
    onBeforeSubmit: (prop_types_default()).func,
    src: (prop_types_default()).string.isRequired,
    disabled: (prop_types_default()).bool,
    customSubmit: (prop_types_default()).bool
};
/* harmony default export */ var comps_PaymentOgone = (PaymentOgone);

// EXTERNAL MODULE: ../../node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(71926);
// EXTERNAL MODULE: ./src/comps/Button/styles.js
var Button_styles = __webpack_require__(13377);
;// CONCATENATED MODULE: ./src/comps/JetIframeForm/styles.js

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  iframe {\n    max-height: 48px;\n  }\n  #paymentErrorMsg {\n    color: ",
        ";\n    margin-block-end: 20px;\n    font-weight: 700;\n  }\n  #old-CVC2-input,\n  #old-pan-input {\n    display: none;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 1.2;\n  margin-block-end: 20px;\n  label {\n    color: ",
        ";\n    margin-block-end: 5px;\n    display: block;\n  }\n  input,\n  select {\n    ",
        "\n  }\n  #paycomet-cvc2 {\n    max-width: 120px;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  max-width: 200px;\n  align-items: center;\n  span {\n    margin-inline: 5px;\n    margin-block: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-block-end: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var JetIframeFormBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__JetIframeFormBase",
    componentId: "sc-6ea2a7a7-0"
})(styles_templateObject(), client_styles/* colors.red2 */.O9.red2);
var JetInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__JetInputWrapper",
    componentId: "sc-6ea2a7a7-1"
})(styles_templateObject1(), client_styles/* colors.grey2 */.O9.grey2, JET_IFRAME_INPUT_STYLES);
var JetInputDatesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__JetInputDatesWrapper",
    componentId: "sc-6ea2a7a7-2"
})(_templateObject2());
var JetButtonSubmit = (0,styled_components_browser_esm/* default */.ZP)(Button_styles/* ButtonPrimary */.DF).withConfig({
    displayName: "styles__JetButtonSubmit",
    componentId: "sc-6ea2a7a7-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/hooks/useGlobalFunction.js

function useGlobalFunction(name, fn) {
    (0,react.useEffect)(function() {
        window[name] = fn;
    }, [
        fn,
        name
    ]);
}
/* harmony default export */ var hooks_useGlobalFunction = (useGlobalFunction);

;// CONCATENATED MODULE: ./src/hooks/useScript.js

var LOADING_STATUS = "loading";
var IDLE_STATUS = "idle";
var READY_STATUS = "ready";
var ERROR_STATUS = "error";
function useScript(url) {
    var ref = (0,react.useState)(url ? LOADING_STATUS : IDLE_STATUS), status = ref[0], setStatus = ref[1];
    (0,react.useEffect)(function() {
        if (!url) {
            setStatus(IDLE_STATUS);
            return function() {};
        }
        var script = document.querySelector('script[src="'.concat(url, '"]'));
        if (!script) {
            script = document.createElement("script");
            script.src = url;
            script.async = true;
            script.setAttribute("data-status", LOADING_STATUS);
            var setAttributeFromEvent = function(event) {
                if (script) {
                    script.setAttribute("data-status", event.type === "load" ? READY_STATUS : ERROR_STATUS);
                }
            };
            script.addEventListener("load", setAttributeFromEvent);
            script.addEventListener("error", setAttributeFromEvent);
            if (document.readyState === "complete") {
                document.body.appendChild(script);
            } else {
                window.addEventListener("load", function() {
                    return document.body.appendChild(script);
                }, false);
            }
        } else {
            setStatus(script.getAttribute("data-status") || IDLE_STATUS);
        }
        var setStateFromEvent = function(event) {
            setStatus(event.type === "load" ? READY_STATUS : ERROR_STATUS);
        };
        script.addEventListener("load", setStateFromEvent);
        script.addEventListener("error", setStateFromEvent);
        return function() {
            if (script) {
                script.removeEventListener("load", setStateFromEvent);
                script.removeEventListener("error", setStateFromEvent);
                script.remove();
            }
        };
    }, [
        url
    ]);
    return status;
}
/* harmony default export */ var hooks_useScript = (useScript);

;// CONCATENATED MODULE: ./src/comps/JetIframeForm/messages.js

var messages_messages = (0,lib/* defineMessages */.vU)({
    cardNumber: {
        id: "paycomet.card-number"
    },
    expiryDate: {
        id: "paycomet.expiry-date"
    },
    cvcCode: {
        id: "paycomet.cvc-code"
    },
    cardHolder: {
        id: "paycomet.card-holder"
    },
    confirmBooking: {
        id: "global.confirm-booking"
    },
    changeCreditCard: {
        id: "payment.change-creditcard"
    }
});
/* harmony default export */ var JetIframeForm_messages = (messages_messages);

;// CONCATENATED MODULE: ./src/comps/JetIframeForm/index.js















var JetIframeForm = function(param) {
    var providerId = param.providerId, purchaseId = param.purchaseId, onSuccess = param.onSuccess, _resetCallback = param.resetCallback, resetCallback = _resetCallback === void 0 ? function() {} : _resetCallback, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _submitCopy = param.submitCopy, submitCopy = _submitCopy === void 0 ? CONFIRM_BUTTON_SUBMIT_VARIANT : _submitCopy, scriptUrl = param.scriptUrl, customSubmit = param.customSubmit, onBeforeSubmit = param.onBeforeSubmit;
    var getNextYears = function getNextYears() {
        return Array.from({
            length: JET_IFRAME_YEARS_COUNT_SELECTOR
        }, function(_, i) {
            return (new Date().getFullYear() + i).toString().substr(-2);
        });
    };
    var formRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (!(typeof onBeforeSubmit === "function")) return [
                            3,
                            2
                        ];
                        setIsSubmitting(true);
                        return [
                            4,
                            onBeforeSubmit()
                        ];
                    case 1:
                        if (!_state.sent()) {
                            setIsSubmitting(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        formRef.current.dispatchEvent(new Event("submit"));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function onFormSubmit() {
        return _onFormSubmit.apply(this, arguments);
    }
    function _onFormSubmit() {
        _onFormSubmit = (0,_async_to_generator/* default */.Z)(function() {
            var requestValues;
            return (0,tslib_es6.__generator)(this, function(_state) {
                requestValues = Array.from(formRef.current).reduce(function(formValues) {
                    var input = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), (0,_define_property/* default */.Z)({}, input.name, input.value));
                });
                onSuccess((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, requestValues), {
                    purchaseId: purchaseId
                }));
                return [
                    2
                ];
            });
        });
        return _onFormSubmit.apply(this, arguments);
    }
    hooks_useGlobalFunction(JET_IFRAME_GLOBAL_CALLBACK_FUNCTION, onFormSubmit);
    var scriptStatus = hooks_useScript(scriptUrl);
    (0,react.useEffect)(function() {
        var creditCardNumberInputs = document.querySelectorAll("#paycomet-pan > iframe").length;
        var cvcInputs = document.querySelectorAll("#paycomet-cvc2 > iframe").length;
        if (scriptStatus === "ready" && creditCardNumberInputs === 0 && cvcInputs === 0) {
            resetCallback();
        }
    }, [
        scriptStatus
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        id: "paycometPaymentForm",
        action: "javascript:".concat(JET_IFRAME_GLOBAL_CALLBACK_FUNCTION, "();"),
        method: "POST",
        ref: formRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                name: "jetID",
                type: "hidden",
                "data-paycomet": "jetID",
                value: providerId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "hidden",
                "data-paycomet": "no-mask",
                value: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(JetInputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "pan",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, JetIframeForm_messages.cardNumber))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "paycomet-pan",
                        "data-paycomet": "paNumber"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        "paycomet-style": JET_IFRAME_INPUT_STYLES,
                        name: "pan",
                        type: "text",
                        id: "old-pan-input",
                        "paycomet-name": "pan" // eslint-disable-line
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(JetInputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "cardHolderName",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, JetIframeForm_messages.cardHolder))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        name: "cardHolderName",
                        type: "text",
                        "data-paycomet": "cardHolderName"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(JetInputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "dateMonth",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, JetIframeForm_messages.expiryDate))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(JetInputDatesWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                "data-paycomet": "dateMonth",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "MM"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "01",
                                        children: "01"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "02",
                                        children: "02"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "03",
                                        children: "03"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "04",
                                        children: "04"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "05",
                                        children: "05"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "06",
                                        children: "06"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "07",
                                        children: "07"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "08",
                                        children: "08"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "09",
                                        children: "09"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "10",
                                        children: "10"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "11",
                                        children: "11"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "12",
                                        children: "12"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                "data-paycomet": "dateYear",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "YY"
                                    }),
                                    getNextYears().map(function(year) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: year,
                                            children: year
                                        }, year);
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(JetInputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "cvc",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, JetIframeForm_messages.cvcCode))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "paycomet-cvc2",
                        "data-paycomet": "cvc2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        "paycomet-style": JET_IFRAME_INPUT_STYLES,
                        name: "cvc",
                        type: "text",
                        id: "old-CVC2-input",
                        "paycomet-name": "cvc2" // eslint-disable-line
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "paymentErrorMsg"
            }),
            customSubmit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                onClick: handleSubmit,
                disabled: disabled || isSubmitting,
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, JetIframeForm_messages[submitCopy]))
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                onClick: handleSubmit,
                disabled: disabled,
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, JetIframeForm_messages[submitCopy]))
            })
        ]
    });
};
JetIframeForm.propTypes = {
    providerId: (prop_types_default()).string.isRequired,
    purchaseId: (prop_types_default()).string.isRequired,
    onSuccess: (prop_types_default()).func.isRequired,
    resetCallback: (prop_types_default()).func.isRequired,
    disabled: (prop_types_default()).bool,
    submitCopy: prop_types_default().oneOf([
        CONFIRM_BUTTON_SUBMIT_VARIANT,
        CHANGE_CREDIT_CARD_BUTTON_SUBMIT_VARIANT, 
    ]),
    scriptUrl: (prop_types_default()).string.isRequired,
    onBeforeSubmit: (prop_types_default()).func,
    customSubmit: (prop_types_default()).bool
};
/* harmony default export */ var comps_JetIframeForm = (JetIframeForm);

// EXTERNAL MODULE: ./src/utils/clientErrorReporter.ts
var clientErrorReporter = __webpack_require__(89987);
;// CONCATENATED MODULE: ./src/comps/JetIframeForm/container.js












var JetIframeFormContainer = function(param) {
    var providerId = param.providerId, purchaseId = param.purchaseId, onSuccess = param.onSuccess, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _submitCopy = param.submitCopy, submitCopy = _submitCopy === void 0 ? CONFIRM_BUTTON_SUBMIT_VARIANT : _submitCopy, customSubmit = param.customSubmit, onBeforeSubmit = param.onBeforeSubmit;
    var stopIframeStatusCheck = function stopIframeStatusCheck() {
        setIframeStatusCheck((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iframeStatusCheck), {
            tries: 0,
            timeout: null
        }));
    };
    var resetIframe = function resetIframe() {
        setIframeStatusCheck((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iframeStatusCheck), {
            display: false
        }));
    };
    var language = (0,useMarket/* useMarket */.A)().language;
    var SCRIPT_URL = "https://api.paycomet.com/gateway/paycomet.jetiframe.js?lang=".concat(language);
    var ref = (0,react.useState)({
        timeout: JET_IFRAME_RENDER_CHECK_INTERVAL,
        tries: JET_IFRAME_RENDER_CHECK_TRIES,
        display: true
    }), iframeStatusCheck = ref[0], setIframeStatusCheck = ref[1];
    (0,useInterval/* default */.Z)(function() {
        var creditCardNumberInputs = document.querySelectorAll("#paycomet-pan > iframe").length;
        var cvcInputs = document.querySelectorAll("#paycomet-cvc2 > iframe").length;
        var remainingTries = iframeStatusCheck.tries - 1;
        if ((creditCardNumberInputs > 1 || cvcInputs > 1) && remainingTries > 1) {
            resetIframe();
        }
        if (creditCardNumberInputs > 1 && remainingTries < 1) {
            (0,clientErrorReporter/* report */.Hj)(new Error("Too many rendered CreditCard fields"));
        }
        if (cvcInputs > 1 && remainingTries < 1) {
            (0,clientErrorReporter/* report */.Hj)(new Error("Too many rendered CVC fields"));
        }
        if (remainingTries < 1) {
            stopIframeStatusCheck();
            return;
        }
        setIframeStatusCheck((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iframeStatusCheck), {
            tries: remainingTries,
            display: true
        }));
    }, iframeStatusCheck.timeout);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JetIframeFormBase, {
        "data-testid": "jet-iframe-form",
        children: iframeStatusCheck.display ? /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_JetIframeForm, {
            providerId: providerId,
            purchaseId: purchaseId,
            onSuccess: onSuccess,
            disabled: disabled,
            submitCopy: submitCopy,
            scriptUrl: SCRIPT_URL,
            resetCallback: resetIframe,
            customSubmit: customSubmit,
            onBeforeSubmit: onBeforeSubmit
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
    });
};
JetIframeFormContainer.propTypes = {
    providerId: (prop_types_default()).string.isRequired,
    purchaseId: (prop_types_default()).string.isRequired,
    onSuccess: (prop_types_default()).func.isRequired,
    disabled: (prop_types_default()).bool,
    submitCopy: prop_types_default().oneOf([
        CONFIRM_BUTTON_SUBMIT_VARIANT,
        CHANGE_CREDIT_CARD_BUTTON_SUBMIT_VARIANT, 
    ]),
    onBeforeSubmit: (prop_types_default()).func,
    customSubmit: (prop_types_default()).bool
};
/* harmony default export */ var container = (JetIframeFormContainer);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./client/contexts/Tracking/actions.js
var Tracking_actions = __webpack_require__(28406);
// EXTERNAL MODULE: ./client/contexts/Tracking/events.js
var events = __webpack_require__(54540);
;// CONCATENATED MODULE: ./src/comps/PaymentWorldlineConnected/index.tsx








var PaymentWorldlineConnected = function(WrappedComponent) {
    var PaymentWorldlineConnectedHandler = function(_param) {
        var onSuccess = _param.onSuccess, _purchaseId = _param.purchaseId, purchaseId = _purchaseId === void 0 ? "" : _purchaseId, props = (0,_object_without_properties/* default */.Z)(_param, [
            "onSuccess",
            "purchaseId"
        ]);
        var dispatch = (0,es/* useDispatch */.I0)();
        var handleValidationSuccess = function(result) {
            dispatch((0,Tracking_actions/* sendTrackingRequestAction */.s)({
                event: (0,events/* checkoutIntent */.rf)({
                    eventName: "payment_attempt",
                    reason: "payment_details_validation",
                    context: "payment_checkout",
                    status: "OK",
                    purchaseId: purchaseId,
                    details: "Payment details validated"
                })
            }));
            if (onSuccess) onSuccess(result);
        };
        var handleValidationError = function() {
            dispatch((0,Tracking_actions/* sendTrackingRequestAction */.s)({
                event: (0,events/* checkoutIntent */.rf)({
                    eventName: "payment_attempt",
                    reason: "payment_details_validation",
                    context: "payment_checkout",
                    status: "KO",
                    purchaseId: purchaseId,
                    details: "Error validating payment details"
                })
            }));
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            onSuccess: handleValidationSuccess,
            onValidationError: handleValidationError,
            purchaseId: purchaseId
        }));
    };
    return PaymentWorldlineConnectedHandler;
};
/* harmony default export */ var comps_PaymentWorldlineConnected = (PaymentWorldlineConnected);

;// CONCATENATED MODULE: ./src/comps/PaymentWorldline/constants.js
var WORLDLINE_PAYMENT_TOKENIZER_SCRIPT = "https://payment.direct.worldline-solutions.com/hostedtokenization/js/client/tokenizer.min.js";

// EXTERNAL MODULE: ./src/comps/PaymentWorldline/styles.module.css
var PaymentWorldline_styles_module = __webpack_require__(82355);
var PaymentWorldline_styles_module_default = /*#__PURE__*/__webpack_require__.n(PaymentWorldline_styles_module);
;// CONCATENATED MODULE: ./src/comps/PaymentWorldline/index.js











var PaymentWorldline = function(param) {
    var src = param.src, onSuccess = param.onSuccess, onError = param.onError, onValidationError = param.onValidationError, onBeforeSubmit = param.onBeforeSubmit, disabled = param.disabled;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var ref2 = (0,react.useState)(null), tokenizer = ref2[0], setTokenizer = ref2[1];
    var ref3 = (0,react.useState)(null), tokenizerScript = ref3[0], setTokenizerScript = ref3[1];
    var isVisible = (0,react.useRef)(false);
    var currentSrc = (0,react.useRef)(src);
    var handleOnError = function(error) {
        onError("Worldline: ".concat(error));
    };
    var cleanupPreviousTokenizer = function() {
        if (tokenizer) {
            setTokenizer(null);
        }
        var container = document.getElementById("div-hosted-tokenization");
        if (container) {
            container.innerHTML = "";
        }
        setIsLoading(true);
    };
    var initializeTokenizer = function() {
        var tokenizationUrl = src;
        if (isVisible.current && document.getElementById("div-hosted-tokenization")) {
            try {
                // eslint-disable-next-line no-undef
                var newTokenizer = new Tokenizer(tokenizationUrl, "div-hosted-tokenization", {
                    hideCardholderName: false
                });
                newTokenizer.initialize().then(function() {
                    setTokenizer(newTokenizer);
                    setIsLoading(false);
                    currentSrc.current = src;
                }).catch(function(error) {
                    var ref;
                    handleOnError("Failed to initialize tokenizer: ".concat((ref = error === null || error === void 0 ? void 0 : error.message) !== null && ref !== void 0 ? ref : error));
                });
            } catch (error) {
                var ref;
                handleOnError("Error creating tokenizer: ".concat((ref = error === null || error === void 0 ? void 0 : error.message) !== null && ref !== void 0 ? ref : error));
            }
        }
    };
    (0,react.useEffect)(function() {
        isVisible.current = true;
        return function() {
            isVisible.current = false;
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isVisible.current) {
            if (!tokenizerScript) {
                var script = document.createElement("script");
                script.src = WORLDLINE_PAYMENT_TOKENIZER_SCRIPT;
                script.async = true;
                script.onload = function() {
                    return initializeTokenizer();
                };
                script.onerror = function() {
                    handleOnError("Failed to load payment script");
                    setIsLoading(false);
                };
                setTokenizerScript(script);
            } else {
                document.body.appendChild(tokenizerScript);
            }
        }
        return function() {
            if (tokenizerScript && document.body.contains(tokenizerScript)) {
                document.body.removeChild(tokenizerScript);
                setTokenizerScript(null);
            }
        };
    }, [
        isVisible,
        tokenizerScript
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    (0,react.useEffect)(function() {
        if (src !== currentSrc.current && tokenizerScript && isVisible.current) {
            cleanupPreviousTokenizer();
            initializeTokenizer();
        }
    }, [
        src
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    function handleSubmit(event) {
        return _handleSubmit.apply(this, arguments);
    }
    function _handleSubmit() {
        _handleSubmit = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (!tokenizer) {
                            handleOnError("Tokenizer not initialized");
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        if (!(typeof onBeforeSubmit === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onBeforeSubmit()
                        ];
                    case 1:
                        if (!_state.sent()) {
                            setIsSubmitting(false);
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(false);
                        _state.label = 2;
                    case 2:
                        tokenizer.submitTokenization().then(function(result) {
                            if (result.success) {
                                onSuccess({
                                    hostedTokenizationId: result.hostedTokenizationId
                                });
                            } else {
                                var ref, ref1, ref2;
                                setIsSubmitting(false);
                                var errorMessage = typeof ((ref = result.error) === null || ref === void 0 ? void 0 : ref.message) === "string" ? (ref1 = result.error) === null || ref1 === void 0 ? void 0 : ref1.message : String((ref2 = result.error) === null || ref2 === void 0 ? void 0 : ref2.message);
                                // don't show error message for field validation errors
                                if (errorMessage.includes("An error occurred: Please check if all fields are correctly filled.")) {
                                    onValidationError();
                                } else {
                                    var _message;
                                    handleOnError((_message = result.error.message) !== null && _message !== void 0 ? _message : result.error);
                                }
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PaymentWorldline_styles_module_default()).iframe,
                id: "div-hosted-tokenization",
                "data-testid": "payment-iframe",
                ref: isVisible
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                "data-testid": "payment-custom-submit",
                disabled: isLoading || disabled || isSubmitting,
                onClick: handleSubmit,
                className: (PaymentWorldline_styles_module_default()).submitButton,
                tabIndex: "0",
                onKeyDown: function(event) {
                    if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleSubmit(event);
                    }
                },
                children: intl.formatMessage({
                    id: "global.confirm-booking"
                })
            })
        ]
    });
};
PaymentWorldline.propTypes = {
    src: (prop_types_default()).string.isRequired,
    onSuccess: (prop_types_default()).func.isRequired,
    onError: (prop_types_default()).func.isRequired,
    onValidationError: (prop_types_default()).func.isRequired,
    onBeforeSubmit: (prop_types_default()).func,
    disabled: (prop_types_default()).bool
};
/* harmony default export */ var comps_PaymentWorldline = (comps_PaymentWorldlineConnected(PaymentWorldline));

// EXTERNAL MODULE: ./client/components/CheckoutContainer/context.js + 1 modules
var context = __webpack_require__(68106);
// EXTERNAL MODULE: ./client/contexts/Purchase/mappers.ts
var mappers = __webpack_require__(75342);
;// CONCATENATED MODULE: ./src/comps/PaymentForm/CreditCardForm.js



















var CreditCardForm_obj;
var paymentFormsMap = (CreditCardForm_obj = {}, (0,_define_property/* default */.Z)(CreditCardForm_obj, mappers/* PaymentMethodEnum.Ogone */.dx.Ogone, comps_PaymentOgone), (0,_define_property/* default */.Z)(CreditCardForm_obj, mappers/* PaymentMethodEnum.Paycomet */.dx.Paycomet, container), (0,_define_property/* default */.Z)(CreditCardForm_obj, mappers/* PaymentMethodEnum.Worldline */.dx.Worldline, comps_PaymentWorldline), CreditCardForm_obj);
var CreditCardForm = function(param) {
    var _creditCard = param.creditCard, creditCard = _creditCard === void 0 ? {} : _creditCard, isPrime = param.isPrime, onError = param.onError, onSuccess = param.onSuccess, onBeforeSubmit = param.onBeforeSubmit, paymentMethods = param.paymentMethods, disabled = param.disabled, purchaseId = param.purchaseId, customSubmit = param.customSubmit;
    var hasSavedCreditCard = function hasSavedCreditCard() {
        return !!(creditCard === null || creditCard === void 0 ? void 0 : creditCard.number);
    };
    var onSubmitSavedCreditCard = function onSubmitSavedCreditCard(event) {
        event.preventDefault();
        onApproveCreditCard({
            kind: paymentMethods.kind
        });
    };
    var ref // keep the value in context
     = (0,react.useContext)(context/* CheckoutContext */.m), isEditingCreditCard = ref.isEditingCreditCard, setIsEditingCreditCard = ref.setIsEditingCreditCard;
    var _creditCard1 = paymentMethods.creditCard, iframeUrl = _creditCard1.url, clientId = _creditCard1.clientId;
    var onApproveCreditCard = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(paymentParams) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(typeof onBeforeSubmit === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onBeforeSubmit()
                        ];
                    case 1:
                        if (!_state.sent()) {
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        onSuccess(constants/* CREDIT_CARD_PAYMENT_METHOD */.io, paymentParams);
                        return [
                            2
                        ];
                }
            });
        });
        return function(paymentParams) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onBeforeSubmit,
        onSuccess
    ]);
    var paymentFormProps = (0,react.useMemo)(function() {
        var commonPaymentFormProps = {
            onSuccess: onApproveCreditCard,
            disabled: disabled,
            customSubmit: customSubmit,
            onBeforeSubmit: onBeforeSubmit,
            providerId: clientId,
            purchaseId: purchaseId
        };
        var _obj;
        var paymentFormPropsMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, mappers/* PaymentMethodEnum.Ogone */.dx.Ogone, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonPaymentFormProps), {
            src: iframeUrl,
            onError: onError
        })), (0,_define_property/* default */.Z)(_obj, mappers/* PaymentMethodEnum.Paycomet */.dx.Paycomet, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonPaymentFormProps), {
            submitCopy: purchaseId ? CONFIRM_BUTTON_SUBMIT_VARIANT : CHANGE_CREDIT_CARD_BUTTON_SUBMIT_VARIANT
        })), (0,_define_property/* default */.Z)(_obj, mappers/* PaymentMethodEnum.Worldline */.dx.Worldline, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonPaymentFormProps), {
            src: iframeUrl,
            onError: onError
        })), _obj);
        return paymentFormPropsMap[paymentMethods.kind];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        paymentMethods.kind,
        iframeUrl
    ]);
    var PaymentForm = paymentFormsMap[paymentMethods.kind];
    if (hasSavedCreditCard() && !isEditingCreditCard) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SavedCreditCardSection */.mv, {
            "data-testid": "credit-card-saved",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardInfo/* default */.Z, (0,_object_spread/* default */.Z)({
                    brand: creditCard.brand,
                    expiryDate: creditCard.expiryDate,
                    holder: creditCard.holder,
                    inputRadioWrapped: true,
                    number: creditCard.number
                }, paymentFormProps)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ChangeCreditCardButton */.Gq, {
                    onClick: function() {
                        return setIsEditingCreditCard(true);
                    },
                    "data-testid": "change-credit-card",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.change-credit-card"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ConfirmBookingSubmit */.Vy, {
                    onClick: onSubmitSavedCreditCard,
                    isPrime: isPrime,
                    disabled: disabled,
                    children: isPrime ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.complete-purchase-prime"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.confirm-booking"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CreditCardFormContainer */.CT, {
        children: [
            hasSavedCreditCard() && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CancelChangeCreditCardButton */.l1, {
                onClick: function() {
                    return setIsEditingCreditCard(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "global.cancel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm, (0,_object_spread/* default */.Z)({}, paymentFormProps))
        ]
    });
};
CreditCardForm.propTypes = {
    creditCard: checkout/* typeCreditCard */.Ko,
    disabled: (prop_types_default()).bool,
    isPrime: (prop_types_default()).bool,
    onError: (prop_types_default()).func.isRequired,
    onSuccess: (prop_types_default()).func.isRequired,
    onBeforeSubmit: (prop_types_default()).func,
    paymentMethods: checkout/* typePaymentMethods */.In,
    purchaseId: (prop_types_default()).string,
    customSubmit: (prop_types_default()).bool
};
/* harmony default export */ var PaymentForm_CreditCardForm = (CreditCardForm);

// EXTERNAL MODULE: ./src/comps/DateIntl/constants.ts
var DateIntl_constants = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/comps/DateIntl/index.tsx
var DateIntl = __webpack_require__(59154);
// EXTERNAL MODULE: ./client/icons/Info.js
var Info = __webpack_require__(3802);
// EXTERNAL MODULE: ./src/comps/ListItem/index.js + 1 modules
var ListItem = __webpack_require__(33665);
// EXTERNAL MODULE: ./client/components/Price/index.js
var Price = __webpack_require__(50992);
;// CONCATENATED MODULE: ./src/comps/PaymentForm/PaymentChangeConditions.js










var PaymentChangeConditions = function(param) {
    var sellingRate = param.sellingRate, cancellationDate = param.cancellationDate, payNow = param.payNow;
    if (!cancellationDate) {
        return null;
    }
    if (cancellationDate && payNow > 0 && payNow < sellingRate) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ConditionsMessage */.xJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ConditionsMessageTitle */.k5, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.change-conditions"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "payment.using-payment-implies-changes"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "payment.pay-now-total-amount"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "payment.cancel-for-free-slf",
                        values: {
                            amount: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                amount: payNow
                            }),
                            date: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                value: cancellationDate,
                                format: DateIntl_constants/* DATE_INTL_FORMAT_MONTH_TEXT */.wl
                            })
                        }
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ConditionsMessage */.xJ, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ConditionsMessageTitle */.k5, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.change-conditions"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                id: "payment.using-payment-implies-changes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "payment.pay-now-total-amount"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "payment.cancel-for-free-nor",
                    values: {
                        date: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                            value: cancellationDate,
                            format: DateIntl_constants/* DATE_INTL_FORMAT_MONTH_TEXT */.wl
                        })
                    }
                })
            })
        ]
    });
};
PaymentChangeConditions.propTypes = {
    sellingRate: (prop_types_default()).number,
    cancellationDate: (prop_types_default()).string,
    payNow: (prop_types_default()).number
};
/* harmony default export */ var PaymentForm_PaymentChangeConditions = (PaymentChangeConditions);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ./src/comps/Page/selectors.js
var Page_selectors = __webpack_require__(91601);
// EXTERNAL MODULE: ./src/comps/Atom/Buttons/Button/index.tsx
var Button = __webpack_require__(9961);
// EXTERNAL MODULE: ./lib/requests.js + 2 modules
var requests = __webpack_require__(68765);
;// CONCATENATED MODULE: ./src/comps/ApplePay/utils.js
function buildApplePayValidateMerchantRequest(param) {
    var purchaseId = param.purchaseId, validationUrl = param.validationUrl, domain = param.domain;
    return {
        purchase_id: purchaseId,
        validation_url: validationUrl,
        domain: domain
    };
}

;// CONCATENATED MODULE: ./src/comps/ApplePay/requests.js




var END_POINTS = {
    APPLEPAY_VALIDATE_MERCHANT: "/applepay/validate"
};
function validateMerchantApplePay(params) {
    return _validateMerchantApplePay.apply(this, arguments);
}
function _validateMerchantApplePay() {
    _validateMerchantApplePay = (0,_async_to_generator/* default */.Z)(function(params) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,requests/* requestByPOST */.Zg)({
                    endpoint: END_POINTS.APPLEPAY_VALIDATE_MERCHANT,
                    data: buildApplePayValidateMerchantRequest(params)
                })
            ];
        });
    });
    return _validateMerchantApplePay.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/comps/ApplePay/constants.ts
var ApplePayMerchantCapabilitiesTypes;
(function(ApplePayMerchantCapabilitiesTypes) {
    ApplePayMerchantCapabilitiesTypes["SUPPORTS_3DS"] = "supports3DS";
    ApplePayMerchantCapabilitiesTypes["SUPPORTS_CREDIT"] = "supportsCredit";
    ApplePayMerchantCapabilitiesTypes["SUPPORTS_DEBIT"] = "supportsDebit";
    ApplePayMerchantCapabilitiesTypes["SUPPORTS_EMV"] = "supportsEMV";
})(ApplePayMerchantCapabilitiesTypes || (ApplePayMerchantCapabilitiesTypes = {}));
var ApplePayLineItemTypes;
(function(ApplePayLineItemTypes) {
    ApplePayLineItemTypes["FINAL"] = "final";
    ApplePayLineItemTypes["PENDING"] = "pending";
})(ApplePayLineItemTypes || (ApplePayLineItemTypes = {}));
var MERCHANT_CAPABILITIES = [
    ApplePayMerchantCapabilitiesTypes.SUPPORTS_3DS
];
var SUPPORTED_NETWORKS = [
    "visa",
    "masterCard",
    "amex"
];
var MERCHANT_LABEL = {
    label: "Stayforlong",
    type: ApplePayLineItemTypes.FINAL
};

;// CONCATENATED MODULE: ./src/comps/ApplePay/index.tsx















var ApplePay = function(param) {
    var onSuccess = param.onSuccess, onError = param.onError, purchaseId = param.purchaseId, tmp = param.payNow, payNowNumber = tmp === void 0 ? 0 : tmp;
    var ref = (0,es/* useSelector */.v9)(Page_selectors/* getBaseParams */.MP), market = ref.market, currency = ref.currency;
    var ref1 = (0,react.useState)(false), isProcessing = ref1[0], setIsProcessing = ref1[1];
    var ref2 = (0,react.useState)(""), domain = ref2[0], setDomain = ref2[1];
    var payNow = payNowNumber === null || payNowNumber === void 0 ? void 0 : payNowNumber.toString();
    var handleOnError = function(error) {
        onError("ApplePay: ".concat(error));
    };
    (0,react.useEffect)(function() {
        if (!domain) setDomain(window.location.hostname);
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    var handleMerchantValidation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var session, validateEvent, response, merchantSession, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        session = param.session, validateEvent = param.validateEvent;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            validateMerchantApplePay({
                                purchaseId: purchaseId,
                                validationUrl: validateEvent.validationURL,
                                domain: domain
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.status !== 200) {
                            throw new Error("Error fetching merchant session: status ".concat(response.status));
                        }
                        merchantSession = response.data.validation_response;
                        session.completeMerchantValidation(merchantSession);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        session.abort();
                        if ((0,_instanceof/* default */.Z)(error, Error)) {
                            handleOnError("Merchant validation failed: ".concat(error.message));
                        } else {
                            handleOnError("Merchant validation failed: Unknown error");
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMerchantValidation(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePaymentAuthorized = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var session, paymentEvent, _header, ephemeralKey, publicKey, _paymentData, paymentData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                session = param.session, paymentEvent = param.paymentEvent;
                try {
                    _header = paymentEvent.payment.token.paymentData.header, ephemeralKey = _header.ephemeralPublicKey, publicKey = _header.publicKeyHash;
                    _paymentData = paymentEvent.payment.token.paymentData, paymentData = _paymentData.data;
                    session.completePayment({
                        status: ApplePaySession.STATUS_SUCCESS
                    });
                    onSuccess(constants/* ALTERNATIVE_PAYMENT_METHOD */.gN, {
                        id: "applePay",
                        purchaseId: purchaseId,
                        ephemeralKey: ephemeralKey,
                        publicKey: publicKey,
                        paymentData: paymentData
                    });
                } catch (error) {
                    session.completePayment({
                        status: ApplePaySession.STATUS_FAILURE
                    });
                    handleOnError("Payment authorization failed");
                }
                return [
                    2
                ];
            });
        });
        return function handlePaymentAuthorized(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleApplePayClick = function(event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        var formattedPayNow = Number(payNow).toFixed(2);
        var paymentDetails = {
            countryCode: market.toUpperCase(),
            currencyCode: currency,
            merchantCapabilities: MERCHANT_CAPABILITIES,
            supportedNetworks: SUPPORTED_NETWORKS,
            total: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MERCHANT_LABEL), {
                amount: formattedPayNow
            })
        };
        try {
            if (payNow <= "0") {
                handleOnError("Payment value must be greater than 0");
                return;
            }
            if (isProcessing || !domain) return;
            setIsProcessing(true);
            if (ApplePaySession === null || ApplePaySession === void 0 ? void 0 : ApplePaySession.canMakePayments()) {
                var session = new ApplePaySession(3, paymentDetails);
                session.onvalidatemerchant = function(validateEvent) {
                    handleMerchantValidation({
                        session: session,
                        validateEvent: validateEvent
                    });
                };
                session.onpaymentauthorized = function(paymentEvent) {
                    handlePaymentAuthorized({
                        session: session,
                        paymentEvent: paymentEvent
                    });
                };
                session.oncancel = function(e) {
                    var ref;
                    var ref1;
                    var reason = (ref1 = e === null || e === void 0 ? void 0 : (ref = e.sessionError) === null || ref === void 0 ? void 0 : ref.code) !== null && ref1 !== void 0 ? ref1 : "No reason provided";
                    handleOnError("User cancelled session with reason: ".concat(reason));
                };
                session.begin();
            } else {
                handleOnError("User browser unable to initialize session");
            }
        } catch (error) {
            handleOnError("Error initializing session");
        } finally{
            setIsProcessing(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        "data-testId": "apple-pay-button",
        onClick: handleApplePayClick,
        disabled: isProcessing,
        size: "m",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                id: "global.pay-with"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PaymentMethodsLogos, {
                applePay: true,
                width: 60,
                height: 46
            })
        ]
    });
};
/* harmony default export */ var comps_ApplePay = (ApplePay);

// EXTERNAL MODULE: ./src/hooks/useSession.ts
var useSession = __webpack_require__(66334);
// EXTERNAL MODULE: ./src/comps/ButtonSimple/index.js
var ButtonSimple = __webpack_require__(11102);
;// CONCATENATED MODULE: ./src/comps/PaymentForm/PaymentData.tsx















var getPaymentFormType = function(paymentMethods) {
    var ref;
    if (((ref = paymentMethods.apm) === null || ref === void 0 ? void 0 : ref.length) || paymentMethods.applePay && (0,utils/* hasApplePaySDK */.NQ)()) {
        return utils/* PaymentFormType.Multiple */.cs.Multiple;
    }
    return utils/* PaymentFormType.Single */.cs.Single;
};
var getAPMButtonVariant = function(apmId) {
    if (apmId === utils/* PaymentTypes.Multibanco */.IX.Multibanco) {
        return "tertiary";
    }
    return "primary";
};
var getAPMName = function(apmId) {
    return utils/* PaymentTypeToNameMap */.Dc[apmId];
};
var SinglePaymentForm = function(param) {
    var creditCard = param.creditCard, disabled = param.disabled, isPrime = param.isPrime, onFail = param.onFail, onSuccess = param.onSuccess, paymentMethods = param.paymentMethods, purchaseId = param.purchaseId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((PaymentForm_styles_module_default()).creditCardContainer, " ").concat((PaymentForm_styles_module_default()).singlePayment),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_CreditCardForm, {
            creditCard: creditCard,
            disabled: disabled,
            isPrime: isPrime,
            onError: onFail,
            onSuccess: onSuccess,
            paymentMethods: paymentMethods,
            purchaseId: purchaseId
        })
    });
};
var MultiplePaymentForm = function(param) {
    var creditCard = param.creditCard, disabled = param.disabled, isPrime = param.isPrime, onFail = param.onFail, onSuccess = param.onSuccess, paymentMethods = param.paymentMethods, purchaseId = param.purchaseId, onSelectedPaymentMethodChange = param.onSelectedPaymentMethodChange, selectedPaymentMethod = param.selectedPaymentMethod, payNow = param.payNow, cancellationDate = param.cancellationDate, sellingRate = param.sellingRate;
    var ref;
    var ref1 = (0,react.useState)(false), isApplePayAvailable = ref1[0], setIsApplePayAvailable = ref1[1];
    var handleApmClick = (0,react.useCallback)(function(apmId) {
        onSuccess(constants/* ALTERNATIVE_PAYMENT_METHOD */.gN, {
            id: apmId
        });
    }, [
        onSuccess
    ]);
    (0,react.useEffect)(function() {
        if (paymentMethods.applePay) {
            setIsApplePayAvailable((0,utils/* hasApplePaySDK */.NQ)());
        }
    }, [
        paymentMethods.applePay
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var apms = (ref = paymentMethods.apm) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var kind = param.kind, value = param.value;
        var APMButtonVariant = getAPMButtonVariant(kind);
        return {
            id: value,
            title: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PaymentMethodsLogos, {
                    apm: kind
                }, "logo"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: getAPMName(kind)
                }, "text"), 
            ],
            body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((PaymentForm_styles_module_default()).apmSubmitButtonContainer, " ").concat(APMButtonVariant === "tertiary" && (PaymentForm_styles_module_default()).tertiary),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentChangeConditions, {
                        sellingRate: sellingRate,
                        cancellationDate: cancellationDate,
                        payNow: payNow
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                        dataTestId: "apm-submit-".concat(kind),
                        onClick: function(event) {
                            event.preventDefault();
                            handleApmClick(value);
                        },
                        text: intl.formatMessage({
                            id: "global.pay-with"
                        }),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PaymentMethodsLogos, {
                            apm: kind,
                            width: 50,
                            height: 40
                        }),
                        variant: APMButtonVariant
                    })
                ]
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_Accordion, {
        onChange: onSelectedPaymentMethodChange,
        selectedSectionId: selectedPaymentMethod,
        sections: (0,_to_consumable_array/* default */.Z)(isApplePayAvailable ? [
            {
                id: "applePay",
                title: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PaymentMethodsLogos, {
                        applePay: true
                    }, "apLogo"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Apple Pay"
                    }, "apText"), 
                ],
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PaymentForm_styles_module_default()).applePayButtonContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_ApplePay, {
                        onSuccess: onSuccess,
                        onError: onFail,
                        purchaseId: purchaseId,
                        payNow: payNow !== null && payNow !== void 0 ? payNow : sellingRate
                    })
                })
            }, 
        ] : []).concat([
            {
                id: constants/* CREDIT_CARD_PAYMENT_METHOD */.io,
                title: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PaymentMethodsLogos, {
                        creditCard: true
                    }, "ccLogo"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Credit / Debit Card"
                    }, "ccText"), 
                ],
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PaymentForm_styles_module_default()).creditCardContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_CreditCardForm, {
                        creditCard: creditCard,
                        disabled: disabled,
                        isPrime: isPrime,
                        onError: onFail,
                        onSuccess: onSuccess,
                        paymentMethods: paymentMethods,
                        purchaseId: purchaseId
                    })
                })
            }, 
        ], (0,_to_consumable_array/* default */.Z)(apms || []))
    });
};
var PaymentData_obj;
var PaymentFormComponentDictionary = (PaymentData_obj = {}, (0,_define_property/* default */.Z)(PaymentData_obj, utils/* PaymentFormType.Single */.cs.Single, SinglePaymentForm), (0,_define_property/* default */.Z)(PaymentData_obj, utils/* PaymentFormType.Multiple */.cs.Multiple, MultiplePaymentForm), PaymentData_obj);
var PaymentData = function(param) {
    var creditCard = param.creditCard, disabled = param.disabled, onFail = param.onFail, onSuccess = param.onSuccess, paymentMethods = param.paymentMethods, purchaseId = param.purchaseId, show = param.show, onSelectedPaymentMethodChange = param.onSelectedPaymentMethodChange, selectedPaymentMethod = param.selectedPaymentMethod, payNow = param.payNow, cancellationDate = param.cancellationDate, sellingRate = param.sellingRate;
    var paymentFormType = getPaymentFormType(paymentMethods);
    var PaymentDataForm = PaymentFormComponentDictionary[paymentFormType];
    var currentUserHasPrimeSubscription = (0,useSession/* useSession */.k)().currentUserHasPrimeSubscription;
    if (show) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentDataForm, {
        creditCard: creditCard,
        disabled: disabled,
        isPrime: currentUserHasPrimeSubscription,
        onFail: onFail,
        onSuccess: onSuccess,
        paymentMethods: paymentMethods,
        purchaseId: purchaseId,
        onSelectedPaymentMethodChange: onSelectedPaymentMethodChange,
        selectedPaymentMethod: selectedPaymentMethod,
        payNow: payNow,
        cancellationDate: cancellationDate,
        sellingRate: sellingRate
    });
};
/* harmony default export */ var PaymentForm_PaymentData = (PaymentData);

;// CONCATENATED MODULE: ./src/comps/PaymentForm/index.js


















var paymentConfirmationTitle = function(param) {
    var consumer = param.consumer, isPrime = param.isPrime;
    if (consumer === constants/* VOUCHER */.uB) {
        return {
            id: "payment.changing-creditcard"
        };
    }
    if (isPrime) {
        return {
            id: "global.completing-your-payment"
        };
    }
    return {
        id: "global.confirming-booking"
    };
};
var paymentConfirmationMessage = function(param) {
    var isPrime = param.isPrime;
    if (!isPrime) {
        return {
            id: "checkout.confirming-booking-message"
        };
    }
    return {
        id: "global.please-wait-few-seconds"
    };
};
var PaymentForm = function(param) {
    var cancellationDate = param.cancellationDate, consumer = param.consumer, error = param.error, subCode = param.subCode, isConfirming = param.isConfirming, paymentModalData = param.paymentModalData, isPrime = param.isPrime, onError = param.onError, onPaymentMethodChange = param.onPaymentMethodChange, onSuccess = param.onSuccess, paymentMethods = param.paymentMethods, payNow = param.payNow, purchaseId = param.purchaseId, sellingRate = param.sellingRate, disabled = param.disabled;
    var dispatch = (0,es/* useDispatch */.I0)();
    var creditCard = (0,es/* useSelector */.v9)(selectors/* getCreditCard */.C$);
    var market = (0,useMarket/* useMarket */.A)().market;
    var apiHostName = (0,useSystem/* useSystem */.u)().apiHostName;
    var isLogged = (0,useSession/* useSession */.k)().isLogged;
    var ref = (0,react.useState)(constants/* CREDIT_CARD_PAYMENT_METHOD */.io), selectedPaymentMethod = ref[0], setSelectedPaymentMethod = ref[1];
    (0,react.useEffect)(function() {
        if (isLogged) {
            dispatch((0,actions/* fetchCustomerCreditCardRequestAction */.K9)({
                hostname: apiHostName,
                market: market
            }));
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    var onSelectedPaymentMethodChange = (0,react.useCallback)(function(paymentMethod) {
        setSelectedPaymentMethod(paymentMethod);
        if (onPaymentMethodChange) {
            onPaymentMethodChange(paymentMethod);
        }
    }, [
        onPaymentMethodChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (PaymentForm_styles_module_default()).paymentForm,
        "data-testid": "payment-form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "".concat((PaymentForm_styles_module_default()).title, " ").concat((PaymentForm_styles_module_default()).desktop),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "global.confirm-booking"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((PaymentForm_styles_module_default()).title, " ").concat((PaymentForm_styles_module_default()).mobile),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "global.credit-debit-card"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PaymentForm_styles_module_default()).subtitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "global.payment-secure"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PaymentForm_styles_module_default()).paymentLogos,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PaymentMethodsLogos, {
                    checkout: true
                })
            }),
            error && !isConfirming && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentErrorMessage, {
                subCode: subCode
            }),
            isConfirming && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentConfirmationLoader, {
                title: paymentConfirmationTitle({
                    consumer: consumer,
                    isPrime: isPrime
                }),
                message: paymentConfirmationMessage({
                    isPrime: isPrime
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentData, {
                creditCard: creditCard,
                disabled: disabled || isConfirming,
                onFail: onError,
                onSuccess: onSuccess,
                paymentMethods: paymentMethods,
                purchaseId: purchaseId,
                show: !!isConfirming,
                onSelectedPaymentMethodChange: onSelectedPaymentMethodChange,
                selectedPaymentMethod: selectedPaymentMethod,
                sellingRate: sellingRate,
                cancellationDate: cancellationDate,
                payNow: payNow
            }),
            paymentModalData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Molecules_PaymentModal, {
                iframeData: paymentModalData,
                onFail: onError
            })
        ]
    });
};
PaymentForm.propTypes = {
    cancellationDate: (prop_types_default()).string,
    consumer: (prop_types_default()).string,
    error: (prop_types_default()).bool,
    subCode: (prop_types_default()).number,
    isConfirming: (prop_types_default()).bool,
    paymentModalData: prop_types_default().shape({
        url: (prop_types_default()).string.isRequired,
        type: (prop_types_default()).string.isRequired
    }),
    isPrime: (prop_types_default()).bool,
    onError: (prop_types_default()).func.isRequired,
    onPaymentMethodChange: (prop_types_default()).func,
    onSuccess: (prop_types_default()).func.isRequired,
    paymentMethods: checkout/* typePaymentMethods */.In,
    payNow: (prop_types_default()).number,
    purchaseId: (prop_types_default()).string,
    sellingRate: (prop_types_default()).number,
    disabled: (prop_types_default()).bool
};
/* harmony default export */ var comps_PaymentForm = (PaymentForm);


/***/ }),

/***/ 40420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ CreditCardFormContainer; },
/* harmony export */   "Gq": function() { return /* binding */ ChangeCreditCardButton; },
/* harmony export */   "RA": function() { return /* binding */ PaymentFormBase; },
/* harmony export */   "Vy": function() { return /* binding */ ConfirmBookingSubmit; },
/* harmony export */   "k5": function() { return /* binding */ ConditionsMessageTitle; },
/* harmony export */   "l1": function() { return /* binding */ CancelChangeCreditCardButton; },
/* harmony export */   "mv": function() { return /* binding */ SavedCreditCardSection; },
/* harmony export */   "my": function() { return /* binding */ ConfirmationTitle; },
/* harmony export */   "q2": function() { return /* binding */ ConfirmationContainer; },
/* harmony export */   "xJ": function() { return /* binding */ ConditionsMessage; }
/* harmony export */ });
/* unused harmony exports Iframe, CreditCardOption */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12411);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);
/* harmony import */ var src_comps_ListItem_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73919);
/* harmony import */ var src_comps_Button_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13377);
/* harmony import */ var src_comps_CreditCardInfo_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65060);
/* harmony import */ var src_styles_colors_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 140%;\n  color: ",
        ";\n  background: ",
        ";\n  padding-block: 20px;\n  padding-inline: 20px;\n\n  ",
        " {\n    border: 2px solid ",
        ";\n    border-radius: 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 400px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active,\n  select:-webkit-autofill,\n  select:-webkit-autofill:hover,\n  select:-webkit-autofill:focus {\n    box-shadow: 0 0 0 30px transparent inset;\n    transition: background-color 5000s ease-in-out 0s;\n  }\n\n  iframe#payment-form-iframe {\n    min-height: 350px;\n  }\n\n  ",
        " {\n    iframe#payment-form-iframe {\n      min-height: auto;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-block: 20px;\n  padding-inline: 20px;\n  margin-block-end: 20px;\n  border-radius: 8px;\n  font-size: 16px;\n  line-height: 150%;\n  color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 8px;\n\n  ",
        " {\n    padding-block-start: 12px;\n    padding-block-end: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-block-end: 12px;\n\n  svg {\n    margin-inline-end: 10px;\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    opacity: 0.5\n  }\n\n  50% {\n    opacity: 1\n  }\n\n  100% {\n    opacity: 0.5\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  max-width: 335px;\n  text-align: center;\n  margin-inline: auto;\n  margin-block: 0;\n  padding-block: 16px 32px;\n  padding-inline: 0;\n  font-size: 16px;\n  line-height: 24px;\n  animation: ",
        " 1.2s ease-out;\n  animation-iteration-count: infinite;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-block: 12px;\n  margin-inline: 0;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  line-height: 24px;\n\n  svg {\n    margin-inline-end: 8px;\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    margin-block-end: 20px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  line-height: 24px;\n  color: ",
        ";\n  padding-block: 10px;\n  padding-inline: 0;\n  text-decoration-line: underline;\n  cursor: pointer;\n  margin-block-end: 20px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  font-size: 16px;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  width: 100%;\n\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}






var PaymentFormBase = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PaymentFormBase",
    componentId: "sc-86fb1d9-0"
})(_templateObject(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .updatedMedia.desktop */ .$c.desktop, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey4 */ .O9.grey4);
var Iframe = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "styles__Iframe",
    componentId: "sc-86fb1d9-1"
})(_templateObject1());
var CreditCardFormContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CreditCardFormContainer",
    componentId: "sc-86fb1d9-2"
})(_templateObject2(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .updatedMedia.desktop */ .$c.desktop);
var ConditionsMessage = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ConditionsMessage",
    componentId: "sc-86fb1d9-3"
})(_templateObject3(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey4 */ .O9.grey4, src_comps_ListItem_styles__WEBPACK_IMPORTED_MODULE_2__/* .ListItemBase */ .Ky);
var ConditionsMessageTitle = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ConditionsMessageTitle",
    componentId: "sc-86fb1d9-4"
})(_templateObject4(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2);
var pulse = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)(_templateObject5());
var ConfirmationContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ConfirmationContainer",
    componentId: "sc-86fb1d9-5"
})(_templateObject6(), pulse, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1);
var ConfirmationTitle = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ConfirmationTitle",
    componentId: "sc-86fb1d9-6"
})(_templateObject7(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1);
var CreditCardOption = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CreditCardOption",
    componentId: "sc-86fb1d9-7"
})(_templateObject8(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2);
var SavedCreditCardSection = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SavedCreditCardSection",
    componentId: "sc-86fb1d9-8"
})(_templateObject9(), src_comps_CreditCardInfo_styles__WEBPACK_IMPORTED_MODULE_4__/* .CreditCardInfoBase */ .Ot);
var ChangeCreditCardButton = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ChangeCreditCardButton",
    componentId: "sc-86fb1d9-9"
})(_templateObject10(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1);
var CancelChangeCreditCardButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(ChangeCreditCardButton).withConfig({
    displayName: "styles__CancelChangeCreditCardButton",
    componentId: "sc-86fb1d9-10"
})(_templateObject11());
var ConfirmBookingSubmit = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(src_comps_Button_styles__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimary */ .DF).withConfig({
    displayName: "styles__ConfirmBookingSubmit",
    componentId: "sc-86fb1d9-11"
})(_templateObject12(), function(props) {
    return props.isPrime ? src_styles_colors_colors__WEBPACK_IMPORTED_MODULE_5__/* ["default"].prime2 */ .Z.prime2 : src_styles_colors_colors__WEBPACK_IMPORTED_MODULE_5__/* ["default"].brand1 */ .Z.brand1;
}, function(props) {
    return props.isPrime ? src_styles_colors_colors__WEBPACK_IMPORTED_MODULE_5__/* ["default"].prime4 */ .Z.prime4 : src_styles_colors_colors__WEBPACK_IMPORTED_MODULE_5__/* ["default"].brand2 */ .Z.brand2;
}, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .updatedMedia.tablet */ .$c.tablet);


/***/ }),

/***/ 47270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dc": function() { return /* binding */ PaymentTypeToNameMap; },
/* harmony export */   "IX": function() { return /* binding */ PaymentTypes; },
/* harmony export */   "NQ": function() { return /* binding */ hasApplePaySDK; },
/* harmony export */   "bG": function() { return /* binding */ PaymentStatus; },
/* harmony export */   "cs": function() { return /* binding */ PaymentFormType; },
/* harmony export */   "lc": function() { return /* binding */ isPaymentStatus; },
/* harmony export */   "oQ": function() { return /* binding */ isPaymentType; },
/* harmony export */   "on": function() { return /* binding */ PaymentMessages; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);

var hasApplePaySDK = function() {
    return  true && typeof window.ApplePaySession !== "undefined";
};
var PaymentFormType;
(function(PaymentFormType) {
    PaymentFormType["Single"] = "single";
    PaymentFormType["Multiple"] = "multiple";
})(PaymentFormType || (PaymentFormType = {}));
var PaymentTypes;
(function(PaymentTypes) {
    PaymentTypes["CreditCard"] = "creditCard";
    PaymentTypes["Klarna"] = "klarna";
    PaymentTypes["GiroPay"] = "giropay";
    PaymentTypes["Ideal"] = "ideal";
    PaymentTypes["Multibanco"] = "multibanco";
    PaymentTypes["Bancontact"] = "bancontact";
})(PaymentTypes || (PaymentTypes = {}));
var _obj;
var PaymentTypeToNameMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PaymentTypes.CreditCard, "Credit Card"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PaymentTypes.Klarna, "Klarna"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PaymentTypes.GiroPay, "GiroPay"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PaymentTypes.Ideal, "iDeal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PaymentTypes.Multibanco, "Multibanco"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PaymentTypes.Bancontact, "Bancontact"), _obj);
var PaymentMessages;
(function(PaymentMessages) {
    PaymentMessages["VALIDATION_3DS"] = "3DS_VALIDATION";
    PaymentMessages["PAYMENT"] = "PAYMENT";
})(PaymentMessages || (PaymentMessages = {}));
var PaymentStatus;
(function(PaymentStatus) {
    PaymentStatus["FAILED"] = "failed";
    PaymentStatus["SUCCESS"] = "success";
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["ERROR"] = "error";
})(PaymentStatus || (PaymentStatus = {}));
var isPaymentType = function(value) {
    return Object.values(PaymentMessages).includes(value);
};
var isPaymentStatus = function(value) {
    return Object.values(PaymentStatus).includes(value);
};


/***/ }),

/***/ 91907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ getCreditCard; },
/* harmony export */   "ab": function() { return /* binding */ getIsFetching; },
/* harmony export */   "hy": function() { return /* binding */ getIsPasswordChanged; },
/* harmony export */   "vC": function() { return /* binding */ getIsUserCreated; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66895);

var getCreditCard = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATE */ .F2].creditCard;
};
var getIsFetching = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATE */ .F2].isFetching;
};
var getIsPasswordChanged = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATE */ .F2].isPasswordChanged;
};
var getIsUserCreated = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATE */ .F2].isUserCreated;
};


/***/ }),

/***/ 7978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A1": function() { return /* binding */ handleConfirmationError; },
/* harmony export */   "IR": function() { return /* binding */ handleCreateAliasError; },
/* harmony export */   "Nq": function() { return /* binding */ handlePaymentMethodError; },
/* harmony export */   "dX": function() { return /* binding */ handlePaymentProviderError; },
/* harmony export */   "ij": function() { return /* binding */ handleInternalError; },
/* harmony export */   "lw": function() { return /* binding */ handleIframeError; },
/* harmony export */   "pf": function() { return /* binding */ handleGeneralError; },
/* harmony export */   "sE": function() { return /* binding */ handleSuccess; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47842);
/* harmony import */ var client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28406);
/* harmony import */ var client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var client_contexts_Tracking_serverSideErrorMapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57598);
/* harmony import */ var client_pages_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11535);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21805);
/* harmony import */ var src_utils_clientErrorReporter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89987);
/* harmony import */ var src_comps_Notifications_PurchaseReminder_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89379);
/* harmony import */ var src_comps_PaymentForm_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47270);









function handleExit(param) {
    var error = param.error, redirectToHotelDetail = param.redirectToHotelDetail;
    (0,src_utils_clientErrorReporter__WEBPACK_IMPORTED_MODULE_6__/* .report */ .Hj)(error);
    redirectToHotelDetail();
    js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].remove */ .Z.remove(src_comps_Notifications_PurchaseReminder_constants__WEBPACK_IMPORTED_MODULE_4__/* .PURCHASE_REMINDER_COOKIE */ .D9);
}
function handleReload(param) {
    var error = param.error, refreshPaymentData = param.refreshPaymentData;
    (0,src_utils_clientErrorReporter__WEBPACK_IMPORTED_MODULE_6__/* .report */ .Hj)(error);
    refreshPaymentData();
}
function handlePaymentMethodError(param) {
    var error = param.error, dispatch = param.dispatch, purchaseId = param.purchaseId;
    dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
        event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
            reason: "payment_methods_provider",
            context: "payment_checkout",
            status: "KO",
            purchaseId: purchaseId,
            details: "Error in payment methods provider: ".concat(error)
        })
    }));
}
function handleCreateAliasError(param) {
    var error = param.error, dispatch = param.dispatch, purchaseId = param.purchaseId, redirectToHotelDetail = param.redirectToHotelDetail;
    var ref, ref1, ref2, ref3;
    var ref4, ref5;
    dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
        event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
            reason: (0,client_contexts_Tracking_serverSideErrorMapper__WEBPACK_IMPORTED_MODULE_7__/* .mapPaymentAliasErrorMessage */ .Nw)((ref4 = (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) !== null && ref4 !== void 0 ? ref4 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.data, (ref5 = (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) !== null && ref5 !== void 0 ? ref5 : 0),
            context: "payment_checkout",
            status: "KO",
            purchaseId: purchaseId,
            details: "Error creating alias"
        })
    }));
    handleExit({
        error: error,
        redirectToHotelDetail: redirectToHotelDetail
    });
    return true;
}
function handleInternalError(param) {
    var code = param.code, error = param.error, dispatch = param.dispatch, purchaseId = param.purchaseId, redirectToHotelDetail = param.redirectToHotelDetail, status = param.status;
    if (code === client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.INTERNAL_ERROR */ .O.INTERNAL_ERROR && error) {
        dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
            event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
                reason: (0,client_contexts_Tracking_serverSideErrorMapper__WEBPACK_IMPORTED_MODULE_7__/* .mapConfirmationErrorMessage */ .hy)(error !== null && error !== void 0 ? error : "", status !== null && status !== void 0 ? status : 0),
                context: "payment_checkout",
                status: "KO",
                purchaseId: purchaseId,
                details: "Error in getConfirmation: ".concat(error)
            })
        }));
        handleExit({
            error: error,
            redirectToHotelDetail: redirectToHotelDetail
        });
        return true;
    }
    return false;
}
function handlePaymentProviderError(param) {
    var code = param.code, subCode = param.subCode, dispatch = param.dispatch, activatePaymentError = param.activatePaymentError, refreshPaymentData = param.refreshPaymentData, setSubCodeError = param.setSubCodeError, purchaseId = param.purchaseId;
    if (code === client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.PAYMENT_PROVIDER */ .O.PAYMENT_PROVIDER && subCode === client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.INVALID_CARD */ .O.INVALID_CARD) {
        dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
            event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
                reason: "confirmation_payment",
                context: "payment_checkout",
                status: "KO",
                purchaseId: purchaseId,
                details: "Error: PAYMENT_PROVIDER and INVALID_CARD"
            })
        }));
        activatePaymentError();
        setSubCodeError(client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.INVALID_CARD */ .O.INVALID_CARD);
        handleReload({
            error: subCode,
            refreshPaymentData: refreshPaymentData
        });
        return true;
    }
    if (code === client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.PAYMENT_PROVIDER */ .O.PAYMENT_PROVIDER || code === client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_PAYMENT */ .O.CONFIRMATION_PAYMENT) {
        dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
            event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
                reason: "confirmation_payment",
                context: "payment_checkout",
                status: "KO",
                purchaseId: purchaseId,
                details: "Error: PAYMENT_PROVIDER or CONFIRMATION_PAYMENT"
            })
        }));
        activatePaymentError();
        setSubCodeError(subCode !== null && subCode !== void 0 ? subCode : null);
        handleReload({
            error: subCode,
            refreshPaymentData: refreshPaymentData
        });
        return true;
    }
    return false;
}
function handleConfirmationError(param) {
    var code = param.code, error = param.error, dispatch = param.dispatch, redirectToHotelDetail = param.redirectToHotelDetail, purchaseId = param.purchaseId, status = param.status;
    var confirmationErrorCodes = [
        client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_BAD_USER */ .O.CONFIRMATION_BAD_USER,
        client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_NOT_PAYABLE */ .O.CONFIRMATION_NOT_PAYABLE,
        client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_PURCHASE_LOCKED */ .O.CONFIRMATION_PURCHASE_LOCKED,
        client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_PURCHASE_ID_NOT_FOUND */ .O.CONFIRMATION_PURCHASE_ID_NOT_FOUND,
        client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_RULES */ .O.CONFIRMATION_RULES, 
    ];
    if ((code === undefined || code === null) && error && status) {
        dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
            event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
                reason: (0,client_contexts_Tracking_serverSideErrorMapper__WEBPACK_IMPORTED_MODULE_7__/* .mapConfirmationErrorMessage */ .hy)(error, status),
                context: "payment_checkout",
                status: "KO",
                purchaseId: purchaseId,
                details: "Error in getConfirmation: ".concat(error)
            })
        }));
        handleExit({
            error: error,
            redirectToHotelDetail: redirectToHotelDetail
        });
        return true;
    }
    if (confirmationErrorCodes.includes(code)) {
        dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
            event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutErrorFrom200 */ .BJ)({
                response: {
                    code: code,
                    error: error
                }
            })
        }));
        var _obj;
        var errorMessages = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_BAD_USER */ .O.CONFIRMATION_BAD_USER, "CONFIRMATION_BAD_USER"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_NOT_PAYABLE */ .O.CONFIRMATION_NOT_PAYABLE, "CONFIRMATION_PAYMENT"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_PURCHASE_LOCKED */ .O.CONFIRMATION_PURCHASE_LOCKED, "CONFIRMATION_PURCHASE_LOCKED"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_PURCHASE_ID_NOT_FOUND */ .O.CONFIRMATION_PURCHASE_ID_NOT_FOUND, "CONFIRMATION_PURCHASE_ID_NOT_FOUND"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, client_pages_constants__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODES.CONFIRMATION_RULES */ .O.CONFIRMATION_RULES, "CONFIRMATION_BOOKING_RULES_CONFIRMATION"), _obj);
        var errorReason = errorMessages[code !== null && code !== void 0 ? code : ""] || "unknown_error";
        var ref;
        var errorDetail = error ? "Error in getConfirmation: ".concat(error) : (ref = errorMessages[code !== null && code !== void 0 ? code : ""]) !== null && ref !== void 0 ? ref : "Unknown error";
        dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
            event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
                reason: errorReason.toLowerCase(),
                context: "payment_checkout",
                status: "KO",
                purchaseId: purchaseId,
                details: errorDetail
            })
        }));
        redirectToHotelDetail();
        return true;
    }
    if (code === "ECONNABORTED") {
        dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
            event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
                reason: "confirmation_timeout",
                context: "payment_checkout",
                status: "KO",
                purchaseId: purchaseId,
                details: "Timeout in getConfirmation: ".concat(error)
            })
        }));
        redirectToHotelDetail();
        return true;
    }
    return false;
}
function handleGeneralError(param) {
    var error = param.error, dispatch = param.dispatch, redirectToHotelDetail = param.redirectToHotelDetail, purchaseId = param.purchaseId;
    dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
        event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutError */ .a3)({
            error: error
        })
    }));
    var _message;
    dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
        event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
            reason: "confirmation_unhandled_error",
            context: "payment_checkout",
            status: "KO",
            purchaseId: purchaseId,
            details: (_message = error.message) !== null && _message !== void 0 ? _message : "Unknown error"
        })
    }));
    handleExit({
        error: error,
        redirectToHotelDetail: redirectToHotelDetail
    });
}
function handleSuccess(param) {
    var dispatch = param.dispatch, purchaseId = param.purchaseId, type = param.type;
    dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
        event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
            reason: type === src_comps_PaymentForm_utils__WEBPACK_IMPORTED_MODULE_5__/* .PaymentMessages.VALIDATION_3DS */ .on.VALIDATION_3DS ? "confirmation_3ds_payment" : "payment_success",
            context: "payment_checkout",
            status: "OK",
            purchaseId: purchaseId,
            details: ""
        })
    }));
}
var handleIframeError = function(param) {
    var error = param.error, dispatch = param.dispatch, purchaseId = param.purchaseId;
    var _eventName;
    dispatch((0,client_contexts_Tracking_actions__WEBPACK_IMPORTED_MODULE_0__/* .sendTrackingRequestAction */ .s)({
        event: (0,client_contexts_Tracking_events__WEBPACK_IMPORTED_MODULE_1__/* .checkoutIntent */ .rf)({
            eventName: (_eventName = error.eventName) !== null && _eventName !== void 0 ? _eventName : "purchase_attempt",
            reason: error.reason,
            context: error.context,
            status: error.status,
            purchaseId: purchaseId,
            details: error.details
        })
    }));
};


/***/ }),

/***/ 50814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ generateTrustedDomains; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50930);
/* harmony import */ var src_constants_countries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83404);


var generateTrustedDomains = function() {
    var testEnv =  false || "production" === "test";
    var trustedDomains = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(src_constants_countries__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOM_DOMAINS */ .EH).concat([
        "www.stayforlong.com"
    ]);
    if (testEnv) {
        var _trustedDomains;
        var baseUrl = "{subdomain}.test.s4long.com";
        var possibleSubdomains = [
            "stable",
            "dev", 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Array.from({
            length: 75
        }, function(_, i) {
            return String(i + 1);
        })));
        (_trustedDomains = trustedDomains).push.apply(_trustedDomains, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(possibleSubdomains.map(function(subdomain) {
            return baseUrl.replace("{subdomain}", subdomain);
        })).concat([
            "localhost:3000" // for e2e
        ]));
    }
    return trustedDomains;
};


/***/ }),

/***/ 48358:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__o23i9","container":"styles_container__uYB88","title":"styles_title__7sPsk","active":"styles_active__VbULQ","body":"styles_body__8R1bg"};

/***/ }),

/***/ 96422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"styles_loadingSpinner__1STs_","spin":"styles_spin__drpX8"};

/***/ }),

/***/ 65126:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__iYSVs","message":"styles_message__GuYUH","preloader":"styles_preloader__ne6Rf","preloaderImage":"styles_preloaderImage__bHXd4","iframe":"styles_iframe__I75jp","loading":"styles_loading__zVJZu","loaded":"styles_loaded__rSdWt","secureConnection":"styles_secureConnection__l9cwc"};

/***/ }),

/***/ 58862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commonPadding":"styles_commonPadding__IlyGl","paymentForm":"styles_paymentForm__xvKp_","title":"styles_title__VnodT styles_commonPadding__IlyGl system_titleXs__EJJjY","subtitle":"styles_subtitle__OLB4a styles_commonPadding__IlyGl","paymentLogos":"styles_paymentLogos__MFTQ9 styles_commonPadding__IlyGl","desktop":"styles_desktop__DB6I5","mobile":"styles_mobile__gc059","applePayButtonContainer":"styles_applePayButtonContainer__ezbEM styles_commonPadding__IlyGl","apmSubmitButtonContainer":"styles_apmSubmitButtonContainer__H2hLW styles_commonPadding__IlyGl","tertiary":"styles_tertiary__r_1Ix","creditCardContainer":"styles_creditCardContainer__WEZQ6 styles_commonPadding__IlyGl","singlePayment":"styles_singlePayment__p7DVE","errorMessageContainer":"styles_errorMessageContainer__cSayt styles_commonPadding__IlyGl","errorMessage":"styles_errorMessage__od4Pd","errorMessageTitle":"styles_errorMessageTitle__uSfPK"};

/***/ }),

/***/ 20424:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logoWithBorder":"styles_logoWithBorder__nxFk0","logosContainer":"styles_logosContainer__khm9q","logo":"styles_logo__baRYn"};

/***/ }),

/***/ 82355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iframe":"styles_iframe__TnTzB","submitButton":"styles_submitButton__B7_19"};

/***/ })

}]);